var items = {
  "block.minecraft.acacia_button": "Boton de rubinia",
  "block.minecraft.acacia_door": "Porta de rubinia",
  "block.minecraft.acacia_fence": "Stongarda de rubinia",
  "block.minecraft.acacia_fence_gate": "Restell de rubinia",
  "block.minecraft.acacia_hanging_sign": "Insegna de rubinia",
  "block.minecraft.acacia_leaves": "Foeuje de rubinia",
  "block.minecraft.acacia_log": "Bora de rubinia",
  "block.minecraft.acacia_planks": "Ass de rubinia",
  "block.minecraft.acacia_pressure_plate": "Pian a pression de rubinia",
  "block.minecraft.acacia_sapling": "But de rubinia",
  "block.minecraft.acacia_shelf": "Scaffale di acacia",
  "block.minecraft.acacia_sign": "Cartell de rubinia",
  "block.minecraft.acacia_slab": "Pioda de rubinia",
  "block.minecraft.acacia_stairs": "Basei de rubinia",
  "block.minecraft.acacia_trapdoor": "Bussera de rubinia",
  "block.minecraft.acacia_wall_hanging_sign": "Insegna a mur de rubinia",
  "block.minecraft.acacia_wall_sign": "Cartell de mur de rubinia",
  "block.minecraft.acacia_wood": "Legn de rubinia",
  "block.minecraft.activator_rail": "Binari pizzador",
  "block.minecraft.air": "Aria",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Bloch de ametista",
  "block.minecraft.amethyst_cluster": "Grapell de ametista",
  "block.minecraft.ancient_debris": "Rest antigh",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Pioda de andesit",
  "block.minecraft.andesite_stairs": "Basei de andesit",
  "block.minecraft.andesite_wall": "Mur de andesit",
  "block.minecraft.anvil": "Incusgen",
  "block.minecraft.attached_melon_stem": "Pianta de inguria madura",
  "block.minecraft.attached_pumpkin_stem": "Pianta de zuca madura",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Foeuje de azalea",
  "block.minecraft.azure_bluet": "Houstonia",
  "block.minecraft.bamboo": "Bamboo",
  "block.minecraft.bamboo_block": "Bloch de bamboo",
  "block.minecraft.bamboo_button": "Boton de bamboo",
  "block.minecraft.bamboo_door": "Porta de bamboo",
  "block.minecraft.bamboo_fence": "Stongarda de bamboo",
  "block.minecraft.bamboo_fence_gate": "Restell de bamboo",
  "block.minecraft.bamboo_hanging_sign": "Insegna de bamboo",
  "block.minecraft.bamboo_mosaic": "Mosaegh de bamboo",
  "block.minecraft.bamboo_mosaic_slab": "Pioda de mosaegh de bamboo",
  "block.minecraft.bamboo_mosaic_stairs": "Basei de mosaegh de bamboo",
  "block.minecraft.bamboo_planks": "Ass de bamboo",
  "block.minecraft.bamboo_pressure_plate": "Pian a pression de bamboo",
  "block.minecraft.bamboo_sapling": "But de bamboo",
  "block.minecraft.bamboo_shelf": "Scaffale di bambù",
  "block.minecraft.bamboo_sign": "Cartell de bamboo",
  "block.minecraft.bamboo_slab": "Pioda de bamboo",
  "block.minecraft.bamboo_stairs": "Basei de bamboo",
  "block.minecraft.bamboo_trapdoor": "Bussera de bamboo",
  "block.minecraft.bamboo_wall_hanging_sign": "Insegna a mur de bamboo",
  "block.minecraft.bamboo_wall_sign": "Cartell de mur de bamboo",
  "block.minecraft.banner.base.black": "Camp negher",
  "block.minecraft.banner.base.blue": "Camp bleou",
  "block.minecraft.banner.base.brown": "Camp marron",
  "block.minecraft.banner.base.cyan": "Camp cian",
  "block.minecraft.banner.base.gray": "Camp gris",
  "block.minecraft.banner.base.green": "Camp verd",
  "block.minecraft.banner.base.light_blue": "Camp bloeu ciar",
  "block.minecraft.banner.base.light_gray": "Camp gris ciar",
  "block.minecraft.banner.base.lime": "Camp lime",
  "block.minecraft.banner.base.magenta": "Camp magenta",
  "block.minecraft.banner.base.orange": "Camp naranz",
  "block.minecraft.banner.base.pink": "Camp roeusa",
  "block.minecraft.banner.base.purple": "Camp vioeula",
  "block.minecraft.banner.base.red": "Camp ross",
  "block.minecraft.banner.base.white": "Camp bianch",
  "block.minecraft.banner.base.yellow": "Camp sgiald",
  "block.minecraft.banner.border.black": "Bordura negra",
  "block.minecraft.banner.border.blue": "Bordura bloeu",
  "block.minecraft.banner.border.brown": "Bordura marrona",
  "block.minecraft.banner.border.cyan": "Bordura ciana",
  "block.minecraft.banner.border.gray": "Bordura grisa",
  "block.minecraft.banner.border.green": "Bordura verda",
  "block.minecraft.banner.border.light_blue": "Bordura bloeu ciar",
  "block.minecraft.banner.border.light_gray": "Bordura gris ciar",
  "block.minecraft.banner.border.lime": "Bordura lime",
  "block.minecraft.banner.border.magenta": "Bordura magenta",
  "block.minecraft.banner.border.orange": "Bordura naranza",
  "block.minecraft.banner.border.pink": "Bordura roeusa",
  "block.minecraft.banner.border.purple": "Bordura vioeula",
  "block.minecraft.banner.border.red": "Bordura rossa",
  "block.minecraft.banner.border.white": "Bordura bianca",
  "block.minecraft.banner.border.yellow": "Bordura sgialda",
  "block.minecraft.banner.bricks.black": "Camp de quadrei negher",
  "block.minecraft.banner.bricks.blue": "Camp de quadrei bloeu",
  "block.minecraft.banner.bricks.brown": "Camp de quadrei marron",
  "block.minecraft.banner.bricks.cyan": "Camp de quadrei celest",
  "block.minecraft.banner.bricks.gray": "Camp de quadrei gris",
  "block.minecraft.banner.bricks.green": "Camp de quadrei verd",
  "block.minecraft.banner.bricks.light_blue": "Camp de quadrei bloeu ciar",
  "block.minecraft.banner.bricks.light_gray": "Camp de quadrei gris ciar",
  "block.minecraft.banner.bricks.lime": "Camp de quadrei lime",
  "block.minecraft.banner.bricks.magenta": "Camp de quadrei magenta",
  "block.minecraft.banner.bricks.orange": "Camp de quadrei naranz",
  "block.minecraft.banner.bricks.pink": "Camp de quadrei roeusa",
  "block.minecraft.banner.bricks.purple": "Camp de quadrei vioeula",
  "block.minecraft.banner.bricks.red": "Camp de quadrei ross",
  "block.minecraft.banner.bricks.white": "Camp de quadrei bianch",
  "block.minecraft.banner.bricks.yellow": "Camp de quadrei sgiald",
  "block.minecraft.banner.circle.black": "Sercet negher",
  "block.minecraft.banner.circle.blue": "Sercet bloeu",
  "block.minecraft.banner.circle.brown": "Sercet marron",
  "block.minecraft.banner.circle.cyan": "Sercet celest",
  "block.minecraft.banner.circle.gray": "Sercet gris",
  "block.minecraft.banner.circle.green": "Sercet verd",
  "block.minecraft.banner.circle.light_blue": "Sercet bloeu ciar",
  "block.minecraft.banner.circle.light_gray": "Sercet gris ciar",
  "block.minecraft.banner.circle.lime": "Sercet lime",
  "block.minecraft.banner.circle.magenta": "Sercet magenta",
  "block.minecraft.banner.circle.orange": "Sercet naranz",
  "block.minecraft.banner.circle.pink": "Sercet roeusa",
  "block.minecraft.banner.circle.purple": "Sercet vioeula",
  "block.minecraft.banner.circle.red": "Sercet ross",
  "block.minecraft.banner.circle.white": "Sercet bianch",
  "block.minecraft.banner.circle.yellow": "Sercet sgiald",
  "block.minecraft.banner.creeper.black": "Faza de creeper negra",
  "block.minecraft.banner.creeper.blue": "Faza de creeper bloeu",
  "block.minecraft.banner.creeper.brown": "Faza de creeper marrona",
  "block.minecraft.banner.creeper.cyan": "Faza de creeper celest",
  "block.minecraft.banner.creeper.gray": "Faza de creeper grisa",
  "block.minecraft.banner.creeper.green": "Faza de creeper verda",
  "block.minecraft.banner.creeper.light_blue": "Faza de creeper bloeu ciar",
  "block.minecraft.banner.creeper.light_gray": "Faza de creeper grisa ciar",
  "block.minecraft.banner.creeper.lime": "Faza de creeper lime",
  "block.minecraft.banner.creeper.magenta": "Faza de creeper magenta",
  "block.minecraft.banner.creeper.orange": "Faza de creeper naranza",
  "block.minecraft.banner.creeper.pink": "Faza de creeper roeusa",
  "block.minecraft.banner.creeper.purple": "Faza de creeper vioeula",
  "block.minecraft.banner.creeper.red": "Faza de creeper rossa",
  "block.minecraft.banner.creeper.white": "Faza da creeper bianca",
  "block.minecraft.banner.creeper.yellow": "Faza de creeper sgialda",
  "block.minecraft.banner.cross.black": "Cros de Sant Andrea negra",
  "block.minecraft.banner.cross.blue": "Cros de Sant Andrea bloeu",
  "block.minecraft.banner.cross.brown": "Cros de Andrea marrona",
  "block.minecraft.banner.cross.cyan": "Cros de Sant Andrea celesta",
  "block.minecraft.banner.cross.gray": "Cros de Sant Andrea grisa",
  "block.minecraft.banner.cross.green": "Cros de Andrea verda",
  "block.minecraft.banner.cross.light_blue": "Cros de Sant Andrea bloeu ciar",
  "block.minecraft.banner.cross.light_gray": "Cros de Sant Andrea grisa ciar",
  "block.minecraft.banner.cross.lime": "Cros de Sant Andrea lime",
  "block.minecraft.banner.cross.magenta": "Cros de Sant Andrea magenta",
  "block.minecraft.banner.cross.orange": "Cros de Sant Andrea naranza",
  "block.minecraft.banner.cross.pink": "Cros de Sant Andrea roeusa",
  "block.minecraft.banner.cross.purple": "Cros de Sant Andrea vioeula",
  "block.minecraft.banner.cross.red": "Cros de Sant Andrea rossa",
  "block.minecraft.banner.cross.white": "Cros de Sant Andrea bianca",
  "block.minecraft.banner.cross.yellow": "Cros de Sant Andrea sgialda",
  "block.minecraft.banner.curly_border.black": "Bordura negra dentada",
  "block.minecraft.banner.curly_border.blue": "Bordura bloeu dentada",
  "block.minecraft.banner.curly_border.brown": "Bordura marrona dentada",
  "block.minecraft.banner.curly_border.cyan": "Bordura ciana dentada",
  "block.minecraft.banner.curly_border.gray": "Bordura grisa dentada",
  "block.minecraft.banner.curly_border.green": "Bordura verda dentada",
  "block.minecraft.banner.curly_border.light_blue": "Bordura bloeu ciar dentada",
  "block.minecraft.banner.curly_border.light_gray": "Bordura gris ciar dentada",
  "block.minecraft.banner.curly_border.lime": "Bordura lime dentada",
  "block.minecraft.banner.curly_border.magenta": "Bordura magenta dentada",
  "block.minecraft.banner.curly_border.orange": "Bordura naranza dentada",
  "block.minecraft.banner.curly_border.pink": "Bordura roeusa dentada",
  "block.minecraft.banner.curly_border.purple": "Bordura vioeula dentada",
  "block.minecraft.banner.curly_border.red": "Bordura rossa dentada",
  "block.minecraft.banner.curly_border.white": "Bordura bianca dentada",
  "block.minecraft.banner.curly_border.yellow": "Bordura sgialda dentada",
  "block.minecraft.banner.diagonal_left.black": "Tajad negher",
  "block.minecraft.banner.diagonal_left.blue": "Tajad bloeu",
  "block.minecraft.banner.diagonal_left.brown": "Tajad marron",
  "block.minecraft.banner.diagonal_left.cyan": "Tajad celest",
  "block.minecraft.banner.diagonal_left.gray": "Tajad gris",
  "block.minecraft.banner.diagonal_left.green": "Tajad verd",
  "block.minecraft.banner.diagonal_left.light_blue": "Tajad bloeu ciar",
  "block.minecraft.banner.diagonal_left.light_gray": "Tajad gris ciar",
  "block.minecraft.banner.diagonal_left.lime": "Tajad lime",
  "block.minecraft.banner.diagonal_left.magenta": "Tajad magenta",
  "block.minecraft.banner.diagonal_left.orange": "Tajad naranz",
  "block.minecraft.banner.diagonal_left.pink": "Tajad roeusa",
  "block.minecraft.banner.diagonal_left.purple": "Tajad vioeula",
  "block.minecraft.banner.diagonal_left.red": "Tajad ross",
  "block.minecraft.banner.diagonal_left.white": "Tajad bianch",
  "block.minecraft.banner.diagonal_left.yellow": "Tajad sgiald",
  "block.minecraft.banner.diagonal_right.black": "Stretajad negher",
  "block.minecraft.banner.diagonal_right.blue": "Stretajad bloeu",
  "block.minecraft.banner.diagonal_right.brown": "Stretajad marron",
  "block.minecraft.banner.diagonal_right.cyan": "Stretajad celest",
  "block.minecraft.banner.diagonal_right.gray": "Stretajad gris",
  "block.minecraft.banner.diagonal_right.green": "Stretajad verd",
  "block.minecraft.banner.diagonal_right.light_blue": "Stretajad bloeu ciar",
  "block.minecraft.banner.diagonal_right.light_gray": "Stretajad gris ciar",
  "block.minecraft.banner.diagonal_right.lime": "Stretajad lime",
  "block.minecraft.banner.diagonal_right.magenta": "Stretajad magenta",
  "block.minecraft.banner.diagonal_right.orange": "Stretajad naranz",
  "block.minecraft.banner.diagonal_right.pink": "Stretajad roeusa",
  "block.minecraft.banner.diagonal_right.purple": "Stretajad vioeula",
  "block.minecraft.banner.diagonal_right.red": "Stretajad ross",
  "block.minecraft.banner.diagonal_right.white": "Stretajad bianch",
  "block.minecraft.banner.diagonal_right.yellow": "Stretajad sgiald",
  "block.minecraft.banner.diagonal_up_left.black": "Stretajad negher a l'invers",
  "block.minecraft.banner.diagonal_up_left.blue": "Stretajad bloeu a l'invers",
  "block.minecraft.banner.diagonal_up_left.brown": "Stretajad marron a l'invers",
  "block.minecraft.banner.diagonal_up_left.cyan": "Stretajad celest a l'invers",
  "block.minecraft.banner.diagonal_up_left.gray": "Stretajad gris a l'invers",
  "block.minecraft.banner.diagonal_up_left.green": "Stretajad verd a l'invers",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Stretajad bloeu ciar a l'invers",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Stretajad gris ciar a l'invers",
  "block.minecraft.banner.diagonal_up_left.lime": "Stretajad lime a l'invers",
  "block.minecraft.banner.diagonal_up_left.magenta": "Stretajad magenta a l'invers",
  "block.minecraft.banner.diagonal_up_left.orange": "Stretajad naranz a l'invers",
  "block.minecraft.banner.diagonal_up_left.pink": "Stretajad roeusa a l'invers",
  "block.minecraft.banner.diagonal_up_left.purple": "Stretajad vioeula a l'invers",
  "block.minecraft.banner.diagonal_up_left.red": "Stretajad ross a l'invers",
  "block.minecraft.banner.diagonal_up_left.white": "Stretajad bianch a l'invers",
  "block.minecraft.banner.diagonal_up_left.yellow": "Stretajad sgiald a l'invers",
  "block.minecraft.banner.diagonal_up_right.black": "Tajad negher a l'invers",
  "block.minecraft.banner.diagonal_up_right.blue": "Tajad bloeu a l'invers",
  "block.minecraft.banner.diagonal_up_right.brown": "Tajad marron a l'invers",
  "block.minecraft.banner.diagonal_up_right.cyan": "Tajad celest a l'invers",
  "block.minecraft.banner.diagonal_up_right.gray": "Tajad gris a l'invers",
  "block.minecraft.banner.diagonal_up_right.green": "Tajad verd a l'invers",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Tajad bloeu ciar a l'invers",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Tajad gris ciar a l'invers",
  "block.minecraft.banner.diagonal_up_right.lime": "Tajad lime a l'invers",
  "block.minecraft.banner.diagonal_up_right.magenta": "Tajad magenta a l'invers",
  "block.minecraft.banner.diagonal_up_right.orange": "Tajad naranz a l'invers",
  "block.minecraft.banner.diagonal_up_right.pink": "Tajad roeusa a l'invers",
  "block.minecraft.banner.diagonal_up_right.purple": "Tajad vioeula a l'invers",
  "block.minecraft.banner.diagonal_up_right.red": "Tajad ross a l'invers",
  "block.minecraft.banner.diagonal_up_right.white": "Tajad bianch a l'invers",
  "block.minecraft.banner.diagonal_up_right.yellow": "Tajad sgiald a l'invers",
  "block.minecraft.banner.flow.black": "Flusso nero",
  "block.minecraft.banner.flow.blue": "Flusso blu",
  "block.minecraft.banner.flow.brown": "Flusso marrone",
  "block.minecraft.banner.flow.cyan": "Flusso ciano",
  "block.minecraft.banner.flow.gray": "Flusso grigio",
  "block.minecraft.banner.flow.green": "Flusso verde",
  "block.minecraft.banner.flow.light_blue": "Flusso azzurro",
  "block.minecraft.banner.flow.light_gray": "Flusso grigio chiaro",
  "block.minecraft.banner.flow.lime": "Flusso lime",
  "block.minecraft.banner.flow.magenta": "Flusso magenta",
  "block.minecraft.banner.flow.orange": "Flusso arancione",
  "block.minecraft.banner.flow.pink": "Flusso rosa",
  "block.minecraft.banner.flow.purple": "Flusso viola",
  "block.minecraft.banner.flow.red": "Flusso rosso",
  "block.minecraft.banner.flow.white": "Flusso bianco",
  "block.minecraft.banner.flow.yellow": "Flusso giallo",
  "block.minecraft.banner.flower.black": "Fior negher",
  "block.minecraft.banner.flower.blue": "Fior bloeu",
  "block.minecraft.banner.flower.brown": "Fior marron",
  "block.minecraft.banner.flower.cyan": "Fior cian",
  "block.minecraft.banner.flower.gray": "Fior gris",
  "block.minecraft.banner.flower.green": "Fior verd",
  "block.minecraft.banner.flower.light_blue": "Fior bloeu ciar",
  "block.minecraft.banner.flower.light_gray": "Fior gris ciar",
  "block.minecraft.banner.flower.lime": "Fior lime",
  "block.minecraft.banner.flower.magenta": "Fior magenta",
  "block.minecraft.banner.flower.orange": "Fior naranz",
  "block.minecraft.banner.flower.pink": "Fior roeusa",
  "block.minecraft.banner.flower.purple": "Fior vioeula",
  "block.minecraft.banner.flower.red": "Fior ross",
  "block.minecraft.banner.flower.white": "Fior bianch",
  "block.minecraft.banner.flower.yellow": "Fior sgiald",
  "block.minecraft.banner.globe.black": "Pianeda negher",
  "block.minecraft.banner.globe.blue": "Pianeda bloeu",
  "block.minecraft.banner.globe.brown": "Pianeda marron",
  "block.minecraft.banner.globe.cyan": "Pianeda cian",
  "block.minecraft.banner.globe.gray": "Pianeda gris",
  "block.minecraft.banner.globe.green": "Pianeda verd",
  "block.minecraft.banner.globe.light_blue": "Pianeda bloeu ciar",
  "block.minecraft.banner.globe.light_gray": "Pianeda gris ciar",
  "block.minecraft.banner.globe.lime": "Pianeda lime",
  "block.minecraft.banner.globe.magenta": "Pianeda magenta",
  "block.minecraft.banner.globe.orange": "Pianeda naranz",
  "block.minecraft.banner.globe.pink": "Pianeda roeusa",
  "block.minecraft.banner.globe.purple": "Pianeda vioeula",
  "block.minecraft.banner.globe.red": "Pianeda ross",
  "block.minecraft.banner.globe.white": "Pianeda bianch",
  "block.minecraft.banner.globe.yellow": "Pianeda sgiald",
  "block.minecraft.banner.gradient.black": "Sfumadura negra",
  "block.minecraft.banner.gradient.blue": "Sfumadura bloeu",
  "block.minecraft.banner.gradient.brown": "Sfumadura marrona",
  "block.minecraft.banner.gradient.cyan": "Sfumadura celesta",
  "block.minecraft.banner.gradient.gray": "Sfumadura grisa",
  "block.minecraft.banner.gradient.green": "Sfumadura verda",
  "block.minecraft.banner.gradient.light_blue": "Sfumadura bloeu ciar",
  "block.minecraft.banner.gradient.light_gray": "Sfumadura gris ciar",
  "block.minecraft.banner.gradient.lime": "Sfumadura lime",
  "block.minecraft.banner.gradient.magenta": "Sfumadura magenta",
  "block.minecraft.banner.gradient.orange": "Sfumadura naranza",
  "block.minecraft.banner.gradient.pink": "Sfumadura roeusa",
  "block.minecraft.banner.gradient.purple": "Sfumadura vioeula",
  "block.minecraft.banner.gradient.red": "Sfumadura rossa",
  "block.minecraft.banner.gradient.white": "Sfumadura bianca",
  "block.minecraft.banner.gradient.yellow": "Sfumadura sgialda",
  "block.minecraft.banner.gradient_up.black": "Sfumadura negra a la bas",
  "block.minecraft.banner.gradient_up.blue": "Sfumadura bloeu a la bas",
  "block.minecraft.banner.gradient_up.brown": "Sfumadura marrona a la bas",
  "block.minecraft.banner.gradient_up.cyan": "Sfumadura cian a la bas",
  "block.minecraft.banner.gradient_up.gray": "Sfumadura grisa a la bas",
  "block.minecraft.banner.gradient_up.green": "Sfumadura verda a la bas",
  "block.minecraft.banner.gradient_up.light_blue": "Sfumadura bloeu ciar a la bas",
  "block.minecraft.banner.gradient_up.light_gray": "Sfumadura gris ciar a la bas",
  "block.minecraft.banner.gradient_up.lime": "Sfumadura lime a la bas",
  "block.minecraft.banner.gradient_up.magenta": "Sfumadura magenta a la bas",
  "block.minecraft.banner.gradient_up.orange": "Sfumadura naranza a la bas",
  "block.minecraft.banner.gradient_up.pink": "Sfumadura roeusa a la bas",
  "block.minecraft.banner.gradient_up.purple": "Sfumadura vioeula a la bas",
  "block.minecraft.banner.gradient_up.red": "Sfumadura rossa a la bas",
  "block.minecraft.banner.gradient_up.white": "Sfumadura bianca a la bas",
  "block.minecraft.banner.gradient_up.yellow": "Sfumadura sgialda a la bas",
  "block.minecraft.banner.guster.black": "Raffica nera",
  "block.minecraft.banner.guster.blue": "Raffica blu",
  "block.minecraft.banner.guster.brown": "Raffica marrone",
  "block.minecraft.banner.guster.cyan": "Raffica ciano",
  "block.minecraft.banner.guster.gray": "Raffica grigia",
  "block.minecraft.banner.guster.green": "Raffica verde",
  "block.minecraft.banner.guster.light_blue": "Raffica azzurra",
  "block.minecraft.banner.guster.light_gray": "Raffica grigio chiaro",
  "block.minecraft.banner.guster.lime": "Raffica lime",
  "block.minecraft.banner.guster.magenta": "Raffica magenta",
  "block.minecraft.banner.guster.orange": "Raffica arancione",
  "block.minecraft.banner.guster.pink": "Raffica rosa",
  "block.minecraft.banner.guster.purple": "Raffica viola",
  "block.minecraft.banner.guster.red": "Raffica rossa",
  "block.minecraft.banner.guster.white": "Raffica bianca",
  "block.minecraft.banner.guster.yellow": "Raffica gialla",
  "block.minecraft.banner.half_horizontal.black": "S'cioncad negher",
  "block.minecraft.banner.half_horizontal.blue": "S'cioncad bloeu",
  "block.minecraft.banner.half_horizontal.brown": "S'cioncad marron",
  "block.minecraft.banner.half_horizontal.cyan": "S'cioncad celest",
  "block.minecraft.banner.half_horizontal.gray": "S'cioncad gris",
  "block.minecraft.banner.half_horizontal.green": "S'cioncad verd",
  "block.minecraft.banner.half_horizontal.light_blue": "S'cioncad bloeu ciar",
  "block.minecraft.banner.half_horizontal.light_gray": "S'cioncad gris ciar",
  "block.minecraft.banner.half_horizontal.lime": "S'cioncad lime",
  "block.minecraft.banner.half_horizontal.magenta": "S'cioncad magenta",
  "block.minecraft.banner.half_horizontal.orange": "S'cioncad naranz",
  "block.minecraft.banner.half_horizontal.pink": "S'cioncad roeusa",
  "block.minecraft.banner.half_horizontal.purple": "S'cioncad vioeula",
  "block.minecraft.banner.half_horizontal.red": "S'cioncad ross",
  "block.minecraft.banner.half_horizontal.white": "S'cioncad bianch",
  "block.minecraft.banner.half_horizontal.yellow": "S'cioncad sgiald",
  "block.minecraft.banner.half_horizontal_bottom.black": "S'cioncad negher a l'invers",
  "block.minecraft.banner.half_horizontal_bottom.blue": "S'cioncad bloeu a l'invers",
  "block.minecraft.banner.half_horizontal_bottom.brown": "S'cioncad marron a l'invers",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "S'cioncad celest a l'invers",
  "block.minecraft.banner.half_horizontal_bottom.gray": "S'cioncad gris a l'invers",
  "block.minecraft.banner.half_horizontal_bottom.green": "S'cioncad verd a l'invers",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "S'cioncad bloeu ciar a l'invers",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "S'cioncad gris ciar a l'invers",
  "block.minecraft.banner.half_horizontal_bottom.lime": "S'cioncad lime a l'invers",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "S'cioncad magenta a l'invers",
  "block.minecraft.banner.half_horizontal_bottom.orange": "S'cioncad naranz a l'invers",
  "block.minecraft.banner.half_horizontal_bottom.pink": "S'cioncad roeusa a l'invers",
  "block.minecraft.banner.half_horizontal_bottom.purple": "S'cioncad vioeula a l'invers",
  "block.minecraft.banner.half_horizontal_bottom.red": "S'cioncad ross a l'invers",
  "block.minecraft.banner.half_horizontal_bottom.white": "S'cioncad bianch a l'invers",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "S'cioncad sgiald a l'invers",
  "block.minecraft.banner.half_vertical.black": "Partid negher",
  "block.minecraft.banner.half_vertical.blue": "Partid bloeu",
  "block.minecraft.banner.half_vertical.brown": "Partid marron",
  "block.minecraft.banner.half_vertical.cyan": "Partid celest",
  "block.minecraft.banner.half_vertical.gray": "Partid gris",
  "block.minecraft.banner.half_vertical.green": "Partid verd",
  "block.minecraft.banner.half_vertical.light_blue": "Partid bloeu ciar",
  "block.minecraft.banner.half_vertical.light_gray": "Partid gris ciar",
  "block.minecraft.banner.half_vertical.lime": "Partid lime",
  "block.minecraft.banner.half_vertical.magenta": "Partid magenta",
  "block.minecraft.banner.half_vertical.orange": "Partid naranz",
  "block.minecraft.banner.half_vertical.pink": "Partid roeusa",
  "block.minecraft.banner.half_vertical.purple": "Partid vioeula",
  "block.minecraft.banner.half_vertical.red": "Partid ross",
  "block.minecraft.banner.half_vertical.white": "Partid bianch",
  "block.minecraft.banner.half_vertical.yellow": "Partid sgiald",
  "block.minecraft.banner.half_vertical_right.black": "Partid negher a l'invers",
  "block.minecraft.banner.half_vertical_right.blue": "Partid bloeu a l'invers",
  "block.minecraft.banner.half_vertical_right.brown": "Partid marron a l'invers",
  "block.minecraft.banner.half_vertical_right.cyan": "Partid celest a l'invers",
  "block.minecraft.banner.half_vertical_right.gray": "Partid gris a l'invers",
  "block.minecraft.banner.half_vertical_right.green": "Partid verd a l'invers",
  "block.minecraft.banner.half_vertical_right.light_blue": "Partid bloeu a l'invers",
  "block.minecraft.banner.half_vertical_right.light_gray": "Partid gris ciar a l'invers",
  "block.minecraft.banner.half_vertical_right.lime": "Partid lime a l'invers",
  "block.minecraft.banner.half_vertical_right.magenta": "Partid magenta a l'invers",
  "block.minecraft.banner.half_vertical_right.orange": "Partid naranz a l'invers",
  "block.minecraft.banner.half_vertical_right.pink": "Partid roeusa a l'invers",
  "block.minecraft.banner.half_vertical_right.purple": "Partid vioeula a l'invers",
  "block.minecraft.banner.half_vertical_right.red": "Partid ross a l'invers",
  "block.minecraft.banner.half_vertical_right.white": "Partid bianch a l'invers",
  "block.minecraft.banner.half_vertical_right.yellow": "Partid sgiald a l'invers",
  "block.minecraft.banner.mojang.black": "Loeugh negher",
  "block.minecraft.banner.mojang.blue": "Loeugh bloeu",
  "block.minecraft.banner.mojang.brown": "Loeugh marron",
  "block.minecraft.banner.mojang.cyan": "Loeugh cian",
  "block.minecraft.banner.mojang.gray": "Loeugh gris",
  "block.minecraft.banner.mojang.green": "Loeugh verd",
  "block.minecraft.banner.mojang.light_blue": "Loeugh bloeu ciar",
  "block.minecraft.banner.mojang.light_gray": "Loeugh gris ciar",
  "block.minecraft.banner.mojang.lime": "Loeugh lime",
  "block.minecraft.banner.mojang.magenta": "Loeugh magenta",
  "block.minecraft.banner.mojang.orange": "Loeugh naranz",
  "block.minecraft.banner.mojang.pink": "Loeugh roeusa",
  "block.minecraft.banner.mojang.purple": "Loeugh vioeula",
  "block.minecraft.banner.mojang.red": "Loeugh ross",
  "block.minecraft.banner.mojang.white": "Loeugh bianch",
  "block.minecraft.banner.mojang.yellow": "Loeugh sgiald",
  "block.minecraft.banner.piglin.black": "Grugn negher",
  "block.minecraft.banner.piglin.blue": "Grugn bloeu",
  "block.minecraft.banner.piglin.brown": "Grugn marron",
  "block.minecraft.banner.piglin.cyan": "Grugn cian",
  "block.minecraft.banner.piglin.gray": "Grugn gris",
  "block.minecraft.banner.piglin.green": "Grugn verd",
  "block.minecraft.banner.piglin.light_blue": "Grugn bloeu ciar",
  "block.minecraft.banner.piglin.light_gray": "Grugn gris ciar",
  "block.minecraft.banner.piglin.lime": "Grugn lime",
  "block.minecraft.banner.piglin.magenta": "Grugn magenta",
  "block.minecraft.banner.piglin.orange": "Grugn naranz",
  "block.minecraft.banner.piglin.pink": "Grugn roeusa",
  "block.minecraft.banner.piglin.purple": "Grugn vioeula",
  "block.minecraft.banner.piglin.red": "Grugn ross",
  "block.minecraft.banner.piglin.white": "Grugn bianch",
  "block.minecraft.banner.piglin.yellow": "Grugn sgiald",
  "block.minecraft.banner.rhombus.black": "Romb negher",
  "block.minecraft.banner.rhombus.blue": "Romb bloeu",
  "block.minecraft.banner.rhombus.brown": "Romb marron",
  "block.minecraft.banner.rhombus.cyan": "Romb celest",
  "block.minecraft.banner.rhombus.gray": "Romb gris",
  "block.minecraft.banner.rhombus.green": "Romb verd",
  "block.minecraft.banner.rhombus.light_blue": "Romb bloeu ciar",
  "block.minecraft.banner.rhombus.light_gray": "Romb gris ciar",
  "block.minecraft.banner.rhombus.lime": "Romb lime",
  "block.minecraft.banner.rhombus.magenta": "Romb magenta",
  "block.minecraft.banner.rhombus.orange": "Romb naranz",
  "block.minecraft.banner.rhombus.pink": "Romb roeusa",
  "block.minecraft.banner.rhombus.purple": "Romb vioeula",
  "block.minecraft.banner.rhombus.red": "Romb ross",
  "block.minecraft.banner.rhombus.white": "Romb bianch",
  "block.minecraft.banner.rhombus.yellow": "Romb sgiald",
  "block.minecraft.banner.skull.black": "Crani negher",
  "block.minecraft.banner.skull.blue": "Crani bloeu",
  "block.minecraft.banner.skull.brown": "Crani marron",
  "block.minecraft.banner.skull.cyan": "Crani cian",
  "block.minecraft.banner.skull.gray": "Crani gris",
  "block.minecraft.banner.skull.green": "Crani verd",
  "block.minecraft.banner.skull.light_blue": "Crani bloeu ciar",
  "block.minecraft.banner.skull.light_gray": "Crani gris ciar",
  "block.minecraft.banner.skull.lime": "Crani lime",
  "block.minecraft.banner.skull.magenta": "Crani magenta",
  "block.minecraft.banner.skull.orange": "Crani naranz",
  "block.minecraft.banner.skull.pink": "Crani roeusa",
  "block.minecraft.banner.skull.purple": "Crani vioeula",
  "block.minecraft.banner.skull.red": "Crani ross",
  "block.minecraft.banner.skull.white": "Crani bianch",
  "block.minecraft.banner.skull.yellow": "Crani sgiald",
  "block.minecraft.banner.small_stripes.black": "Palad negher",
  "block.minecraft.banner.small_stripes.blue": "Palad bloeu",
  "block.minecraft.banner.small_stripes.brown": "Palad marron",
  "block.minecraft.banner.small_stripes.cyan": "Palad celest",
  "block.minecraft.banner.small_stripes.gray": "Palad gris",
  "block.minecraft.banner.small_stripes.green": "Palad verd",
  "block.minecraft.banner.small_stripes.light_blue": "Palad bloeu ciar",
  "block.minecraft.banner.small_stripes.light_gray": "Palad gris ciar",
  "block.minecraft.banner.small_stripes.lime": "Palad lime",
  "block.minecraft.banner.small_stripes.magenta": "Palad magenta",
  "block.minecraft.banner.small_stripes.orange": "Palad naranz",
  "block.minecraft.banner.small_stripes.pink": "Palad roeusa",
  "block.minecraft.banner.small_stripes.purple": "Palad vioeula",
  "block.minecraft.banner.small_stripes.red": "Palad ross",
  "block.minecraft.banner.small_stripes.white": "Palad bianch",
  "block.minecraft.banner.small_stripes.yellow": "Palad sgiald",
  "block.minecraft.banner.square_bottom_left.black": "Canton drizz negher de la guzza",
  "block.minecraft.banner.square_bottom_left.blue": "Canton drizz bloeu de la guzza",
  "block.minecraft.banner.square_bottom_left.brown": "Canton drizz marron de la guzza",
  "block.minecraft.banner.square_bottom_left.cyan": "Canton drizz celest de la guzza",
  "block.minecraft.banner.square_bottom_left.gray": "Canton drizz gris de la guzza",
  "block.minecraft.banner.square_bottom_left.green": "Canton drizz verd de la guzza",
  "block.minecraft.banner.square_bottom_left.light_blue": "Canton drizz bloeu ciar de la guzza",
  "block.minecraft.banner.square_bottom_left.light_gray": "Canton drizz gris ciar de la guzza",
  "block.minecraft.banner.square_bottom_left.lime": "Canton drizz de la guzza",
  "block.minecraft.banner.square_bottom_left.magenta": "Canton drizz magenta de la guzza",
  "block.minecraft.banner.square_bottom_left.orange": "Canton drizz naranz de la guzza",
  "block.minecraft.banner.square_bottom_left.pink": "Canton drizz roeusa de la guzza",
  "block.minecraft.banner.square_bottom_left.purple": "Canton drizz vioeula de la guzza",
  "block.minecraft.banner.square_bottom_left.red": "Canton drizz ross de la guzza",
  "block.minecraft.banner.square_bottom_left.white": "Canton drizz bianch de la guzza",
  "block.minecraft.banner.square_bottom_left.yellow": "Canton drizz sgiald de la guzza",
  "block.minecraft.banner.square_bottom_right.black": "Canton manzin negher de la guzza",
  "block.minecraft.banner.square_bottom_right.blue": "Canton manzin bloeu de la guzza",
  "block.minecraft.banner.square_bottom_right.brown": "Canton manzin marron de la guzza",
  "block.minecraft.banner.square_bottom_right.cyan": "Canton manzin celest de la guzza",
  "block.minecraft.banner.square_bottom_right.gray": "Canton manzin gris de la guzza",
  "block.minecraft.banner.square_bottom_right.green": "Canton manzin verd de la guzza",
  "block.minecraft.banner.square_bottom_right.light_blue": "Canton manzin bloeu ciar de la guzza",
  "block.minecraft.banner.square_bottom_right.light_gray": "Canton manzin gris ciar de la guzza",
  "block.minecraft.banner.square_bottom_right.lime": "Canton manzin lime de la guzza",
  "block.minecraft.banner.square_bottom_right.magenta": "Canton manzin magenta de la guzza",
  "block.minecraft.banner.square_bottom_right.orange": "Canton manzin naranz de la guzza",
  "block.minecraft.banner.square_bottom_right.pink": "Canton manzin roeusa de la guzza",
  "block.minecraft.banner.square_bottom_right.purple": "Canton manzin vioeula de la guzza",
  "block.minecraft.banner.square_bottom_right.red": "Canton manzin ross de la guzza",
  "block.minecraft.banner.square_bottom_right.white": "Canton manzin bianch de la guzza",
  "block.minecraft.banner.square_bottom_right.yellow": "Canton manzin sgiald de la guzza",
  "block.minecraft.banner.square_top_left.black": "Canton drizz negher del capo",
  "block.minecraft.banner.square_top_left.blue": "Canton drizz bloeu del capo",
  "block.minecraft.banner.square_top_left.brown": "Canton drizz marron del capo",
  "block.minecraft.banner.square_top_left.cyan": "Canton drizz celest del capo",
  "block.minecraft.banner.square_top_left.gray": "Canton drizz gris del capo",
  "block.minecraft.banner.square_top_left.green": "Canton drizz verd del capo",
  "block.minecraft.banner.square_top_left.light_blue": "Canton drizz bloeu ciar del capo",
  "block.minecraft.banner.square_top_left.light_gray": "Canton drizz gris ciar del capo",
  "block.minecraft.banner.square_top_left.lime": "Canton drizz lime del capo",
  "block.minecraft.banner.square_top_left.magenta": "Canton drizz magenta del capo",
  "block.minecraft.banner.square_top_left.orange": "Canton drizz naranz del capo",
  "block.minecraft.banner.square_top_left.pink": "Canton drizz roeusa del capo",
  "block.minecraft.banner.square_top_left.purple": "Canton drizz vioeula del capo",
  "block.minecraft.banner.square_top_left.red": "Canton ross negher del capo",
  "block.minecraft.banner.square_top_left.white": "Canton drizz bianch del capo",
  "block.minecraft.banner.square_top_left.yellow": "Canton drizz sgiald del capo",
  "block.minecraft.banner.square_top_right.black": "Canton manzin negher del capo",
  "block.minecraft.banner.square_top_right.blue": "Canton manzin bloeu del capo",
  "block.minecraft.banner.square_top_right.brown": "Canton manzin marron del capo",
  "block.minecraft.banner.square_top_right.cyan": "Canton manzin celest del capo",
  "block.minecraft.banner.square_top_right.gray": "Canton manzin gris del capo",
  "block.minecraft.banner.square_top_right.green": "Canton manzin verd del capo",
  "block.minecraft.banner.square_top_right.light_blue": "Canton manzin bloeu ciar del capo",
  "block.minecraft.banner.square_top_right.light_gray": "Canton manzin gris ciar del capo",
  "block.minecraft.banner.square_top_right.lime": "Canton manzin lime del capo",
  "block.minecraft.banner.square_top_right.magenta": "Canton manzin magenta del capo",
  "block.minecraft.banner.square_top_right.orange": "Canton manzin naranz del capo",
  "block.minecraft.banner.square_top_right.pink": "Canton manzin roeusa del capo",
  "block.minecraft.banner.square_top_right.purple": "Canton manzin vioeula del capo",
  "block.minecraft.banner.square_top_right.red": "Canton ross negher del capo",
  "block.minecraft.banner.square_top_right.white": "Canton manzin bianch del capo",
  "block.minecraft.banner.square_top_right.yellow": "Canton manzin sgiald del capo",
  "block.minecraft.banner.straight_cross.black": "Cros negra",
  "block.minecraft.banner.straight_cross.blue": "Cros bloeu",
  "block.minecraft.banner.straight_cross.brown": "Cros marrona",
  "block.minecraft.banner.straight_cross.cyan": "Cros ciana",
  "block.minecraft.banner.straight_cross.gray": "Cros grisa",
  "block.minecraft.banner.straight_cross.green": "Cros verda",
  "block.minecraft.banner.straight_cross.light_blue": "Cros bloeu ciara",
  "block.minecraft.banner.straight_cross.light_gray": "Cros grisa ciara",
  "block.minecraft.banner.straight_cross.lime": "Cros lime",
  "block.minecraft.banner.straight_cross.magenta": "Cros magenta",
  "block.minecraft.banner.straight_cross.orange": "Cros naranza",
  "block.minecraft.banner.straight_cross.pink": "Cros roeusa",
  "block.minecraft.banner.straight_cross.purple": "Cros vioeula",
  "block.minecraft.banner.straight_cross.red": "Cros rossa",
  "block.minecraft.banner.straight_cross.white": "Cros bianca",
  "block.minecraft.banner.straight_cross.yellow": "Cros sgialda",
  "block.minecraft.banner.stripe_bottom.black": "Fassa negra",
  "block.minecraft.banner.stripe_bottom.blue": "Fassa bloeu",
  "block.minecraft.banner.stripe_bottom.brown": "Fassa marrona",
  "block.minecraft.banner.stripe_bottom.cyan": "Fassa celesta",
  "block.minecraft.banner.stripe_bottom.gray": "Fassa grisa",
  "block.minecraft.banner.stripe_bottom.green": "Fassa verda",
  "block.minecraft.banner.stripe_bottom.light_blue": "Fassa bloeu ciar",
  "block.minecraft.banner.stripe_bottom.light_gray": "Fassa grisa ciar",
  "block.minecraft.banner.stripe_bottom.lime": "Fassa lime",
  "block.minecraft.banner.stripe_bottom.magenta": "Fassa magenta",
  "block.minecraft.banner.stripe_bottom.orange": "Fassa naranza",
  "block.minecraft.banner.stripe_bottom.pink": "Fassa roeusa",
  "block.minecraft.banner.stripe_bottom.purple": "Fassa vioeula",
  "block.minecraft.banner.stripe_bottom.red": "Fassa rossa",
  "block.minecraft.banner.stripe_bottom.white": "Fassa bianca",
  "block.minecraft.banner.stripe_bottom.yellow": "Fassa sgialda",
  "block.minecraft.banner.stripe_center.black": "Pal negher",
  "block.minecraft.banner.stripe_center.blue": "Pal bloeu",
  "block.minecraft.banner.stripe_center.brown": "Pal marron",
  "block.minecraft.banner.stripe_center.cyan": "Pal celest",
  "block.minecraft.banner.stripe_center.gray": "Pal gris",
  "block.minecraft.banner.stripe_center.green": "Pal verd",
  "block.minecraft.banner.stripe_center.light_blue": "Pal bloeu ciar",
  "block.minecraft.banner.stripe_center.light_gray": "Pal gris ciar",
  "block.minecraft.banner.stripe_center.lime": "Pal lime",
  "block.minecraft.banner.stripe_center.magenta": "Pal magenta",
  "block.minecraft.banner.stripe_center.orange": "Pal naranz",
  "block.minecraft.banner.stripe_center.pink": "Pal roeusa",
  "block.minecraft.banner.stripe_center.purple": "Pal vioeula",
  "block.minecraft.banner.stripe_center.red": "Pal ross",
  "block.minecraft.banner.stripe_center.white": "Pal bianch",
  "block.minecraft.banner.stripe_center.yellow": "Pal sgiald",
  "block.minecraft.banner.stripe_downleft.black": "Banda manzina negra",
  "block.minecraft.banner.stripe_downleft.blue": "Banda manzina bloeu",
  "block.minecraft.banner.stripe_downleft.brown": "Banda manzina marrona",
  "block.minecraft.banner.stripe_downleft.cyan": "Banda manzina celesta",
  "block.minecraft.banner.stripe_downleft.gray": "Banda manzina grisa",
  "block.minecraft.banner.stripe_downleft.green": "Banda manzina verda",
  "block.minecraft.banner.stripe_downleft.light_blue": "Banda manzina bloeu ciar",
  "block.minecraft.banner.stripe_downleft.light_gray": "Banda manzina grisa ciar",
  "block.minecraft.banner.stripe_downleft.lime": "Banda manzina lime",
  "block.minecraft.banner.stripe_downleft.magenta": "Banda manzina magenta",
  "block.minecraft.banner.stripe_downleft.orange": "Banda manzina naranza",
  "block.minecraft.banner.stripe_downleft.pink": "Banda manzina roeusa",
  "block.minecraft.banner.stripe_downleft.purple": "Banda manzina vioeula",
  "block.minecraft.banner.stripe_downleft.red": "Banda manzina rossa",
  "block.minecraft.banner.stripe_downleft.white": "Banda manzina bianca",
  "block.minecraft.banner.stripe_downleft.yellow": "Banda manzina sgialda",
  "block.minecraft.banner.stripe_downright.black": "Banda negra",
  "block.minecraft.banner.stripe_downright.blue": "Banda bloeu",
  "block.minecraft.banner.stripe_downright.brown": "Banda marrona",
  "block.minecraft.banner.stripe_downright.cyan": "Banda celesta",
  "block.minecraft.banner.stripe_downright.gray": "Banda grisa",
  "block.minecraft.banner.stripe_downright.green": "Banda verda",
  "block.minecraft.banner.stripe_downright.light_blue": "Banda bloeu ciar",
  "block.minecraft.banner.stripe_downright.light_gray": "Banda grisa ciar",
  "block.minecraft.banner.stripe_downright.lime": "Banda lime",
  "block.minecraft.banner.stripe_downright.magenta": "Banda magenta",
  "block.minecraft.banner.stripe_downright.orange": "Banda naranza",
  "block.minecraft.banner.stripe_downright.pink": "Banda roeusa",
  "block.minecraft.banner.stripe_downright.purple": "Banda vioeula",
  "block.minecraft.banner.stripe_downright.red": "Banda rossa",
  "block.minecraft.banner.stripe_downright.white": "Banda bianca",
  "block.minecraft.banner.stripe_downright.yellow": "Banda sgialda",
  "block.minecraft.banner.stripe_left.black": "Pal drizz negher",
  "block.minecraft.banner.stripe_left.blue": "Pal drizz bloeu",
  "block.minecraft.banner.stripe_left.brown": "Pal drizz marron",
  "block.minecraft.banner.stripe_left.cyan": "Pal drizz celest",
  "block.minecraft.banner.stripe_left.gray": "Pal drizz gris",
  "block.minecraft.banner.stripe_left.green": "Pal drizz verd",
  "block.minecraft.banner.stripe_left.light_blue": "Pal drizz bloeu ciar",
  "block.minecraft.banner.stripe_left.light_gray": "Pal drizz gris ciar",
  "block.minecraft.banner.stripe_left.lime": "Pal drizz lime",
  "block.minecraft.banner.stripe_left.magenta": "Pal drizz magenta",
  "block.minecraft.banner.stripe_left.orange": "Pal drizz naranz",
  "block.minecraft.banner.stripe_left.pink": "Pal drizz roeusa",
  "block.minecraft.banner.stripe_left.purple": "Pal drizz vioeula",
  "block.minecraft.banner.stripe_left.red": "Pal drizz ross",
  "block.minecraft.banner.stripe_left.white": "Pal drizz bianch",
  "block.minecraft.banner.stripe_left.yellow": "Pal drizz sgiald",
  "block.minecraft.banner.stripe_middle.black": "Fassa negra",
  "block.minecraft.banner.stripe_middle.blue": "Fassa bloeu",
  "block.minecraft.banner.stripe_middle.brown": "Fassa marrona",
  "block.minecraft.banner.stripe_middle.cyan": "Fassa celesta",
  "block.minecraft.banner.stripe_middle.gray": "Fassa grisa",
  "block.minecraft.banner.stripe_middle.green": "Fassa verda",
  "block.minecraft.banner.stripe_middle.light_blue": "Fassa bloeu ciar",
  "block.minecraft.banner.stripe_middle.light_gray": "Fassa grisa ciar",
  "block.minecraft.banner.stripe_middle.lime": "Fassa lime",
  "block.minecraft.banner.stripe_middle.magenta": "Fassa magenta",
  "block.minecraft.banner.stripe_middle.orange": "Fassa naranza",
  "block.minecraft.banner.stripe_middle.pink": "Fassa roeusa",
  "block.minecraft.banner.stripe_middle.purple": "Fassa vioeula",
  "block.minecraft.banner.stripe_middle.red": "Fassa rossa",
  "block.minecraft.banner.stripe_middle.white": "Fassa bianca",
  "block.minecraft.banner.stripe_middle.yellow": "Fassa sgialda",
  "block.minecraft.banner.stripe_right.black": "Pal manzin negher",
  "block.minecraft.banner.stripe_right.blue": "Pal manzin bloeu",
  "block.minecraft.banner.stripe_right.brown": "Pal manzin marron",
  "block.minecraft.banner.stripe_right.cyan": "Pal manzin celest",
  "block.minecraft.banner.stripe_right.gray": "Pal manzin gris",
  "block.minecraft.banner.stripe_right.green": "Pal manzin verd",
  "block.minecraft.banner.stripe_right.light_blue": "Pal manzin bloeu ciar",
  "block.minecraft.banner.stripe_right.light_gray": "Pal manzin gris ciar",
  "block.minecraft.banner.stripe_right.lime": "Pal manzin lime",
  "block.minecraft.banner.stripe_right.magenta": "Pal manzin magenta",
  "block.minecraft.banner.stripe_right.orange": "Pal manzin naranz",
  "block.minecraft.banner.stripe_right.pink": "Pal manzin roeusa",
  "block.minecraft.banner.stripe_right.purple": "Pal manzin vioeula",
  "block.minecraft.banner.stripe_right.red": "Pal manzin ross",
  "block.minecraft.banner.stripe_right.white": "Pal manzin bianch",
  "block.minecraft.banner.stripe_right.yellow": "Pal manzin sgiald",
  "block.minecraft.banner.stripe_top.black": "Fassa capo negra",
  "block.minecraft.banner.stripe_top.blue": "Fassa capo bloeu",
  "block.minecraft.banner.stripe_top.brown": "Fassa capo marrona",
  "block.minecraft.banner.stripe_top.cyan": "Fassa capo celesta",
  "block.minecraft.banner.stripe_top.gray": "Fassa capo grisa",
  "block.minecraft.banner.stripe_top.green": "Fassa capo verda",
  "block.minecraft.banner.stripe_top.light_blue": "Fassa capo bloeu ciar",
  "block.minecraft.banner.stripe_top.light_gray": "Fassa capo grisa ciar",
  "block.minecraft.banner.stripe_top.lime": "Fassa capo lime",
  "block.minecraft.banner.stripe_top.magenta": "Fassa capo magenta",
  "block.minecraft.banner.stripe_top.orange": "Fassa capo naranza",
  "block.minecraft.banner.stripe_top.pink": "Fassa capo roeusa",
  "block.minecraft.banner.stripe_top.purple": "Fassa capo vioeula",
  "block.minecraft.banner.stripe_top.red": "Fassa capo rossa",
  "block.minecraft.banner.stripe_top.white": "Fassa capo bianca",
  "block.minecraft.banner.stripe_top.yellow": "Fassa capo sgialda",
  "block.minecraft.banner.triangle_bottom.black": "Guzza negra",
  "block.minecraft.banner.triangle_bottom.blue": "Guzza bloeu",
  "block.minecraft.banner.triangle_bottom.brown": "Guzza marrona",
  "block.minecraft.banner.triangle_bottom.cyan": "Guzza celesta",
  "block.minecraft.banner.triangle_bottom.gray": "Guzza grisa",
  "block.minecraft.banner.triangle_bottom.green": "Guzza verda",
  "block.minecraft.banner.triangle_bottom.light_blue": "Guzza bloeu ciar",
  "block.minecraft.banner.triangle_bottom.light_gray": "Guzza grisa ciar",
  "block.minecraft.banner.triangle_bottom.lime": "Guzza lime",
  "block.minecraft.banner.triangle_bottom.magenta": "Guzza magenta",
  "block.minecraft.banner.triangle_bottom.orange": "Guzza naranza",
  "block.minecraft.banner.triangle_bottom.pink": "Guzza roeusa",
  "block.minecraft.banner.triangle_bottom.purple": "Guzza vioeula",
  "block.minecraft.banner.triangle_bottom.red": "Guzza rossa",
  "block.minecraft.banner.triangle_bottom.white": "Guzza bianca",
  "block.minecraft.banner.triangle_bottom.yellow": "Guzza sgialda",
  "block.minecraft.banner.triangle_top.black": "Guzza negra a l'invers",
  "block.minecraft.banner.triangle_top.blue": "Guzza bloeu a l'invers",
  "block.minecraft.banner.triangle_top.brown": "Guzza marrona a l'invers",
  "block.minecraft.banner.triangle_top.cyan": "Guzza celesta a l'invers",
  "block.minecraft.banner.triangle_top.gray": "Guzza grisa a l'invers",
  "block.minecraft.banner.triangle_top.green": "Guzza verda a l'invers",
  "block.minecraft.banner.triangle_top.light_blue": "Guzza bloeu ciar a l'invers",
  "block.minecraft.banner.triangle_top.light_gray": "Guzza grisa ciar a l'invers",
  "block.minecraft.banner.triangle_top.lime": "Guzza lime a l'invers",
  "block.minecraft.banner.triangle_top.magenta": "Guzza magenta a l'invers",
  "block.minecraft.banner.triangle_top.orange": "Guzza naranza a l'invers",
  "block.minecraft.banner.triangle_top.pink": "Guzza roeusa a l'invers",
  "block.minecraft.banner.triangle_top.purple": "Guzza vioeula a l'invers",
  "block.minecraft.banner.triangle_top.red": "Guzza rossa a l'invers",
  "block.minecraft.banner.triangle_top.white": "Guzza bianca a l'invers",
  "block.minecraft.banner.triangle_top.yellow": "Guzza sgialda a l'invers",
  "block.minecraft.banner.triangles_bottom.black": "Bas negra dentada",
  "block.minecraft.banner.triangles_bottom.blue": "Bas bloeu dentada",
  "block.minecraft.banner.triangles_bottom.brown": "Bas marrona dentada",
  "block.minecraft.banner.triangles_bottom.cyan": "Bas celesta dentada",
  "block.minecraft.banner.triangles_bottom.gray": "Bas grisa dentada",
  "block.minecraft.banner.triangles_bottom.green": "Bas verda dentada",
  "block.minecraft.banner.triangles_bottom.light_blue": "Bas bloeu ciar dentada",
  "block.minecraft.banner.triangles_bottom.light_gray": "Bas grisa ciar dentada",
  "block.minecraft.banner.triangles_bottom.lime": "Bas lime dentada",
  "block.minecraft.banner.triangles_bottom.magenta": "Bas magenta dentada",
  "block.minecraft.banner.triangles_bottom.orange": "Bas naranza dentada",
  "block.minecraft.banner.triangles_bottom.pink": "Bas roeusa dentada",
  "block.minecraft.banner.triangles_bottom.purple": "Bas vioeula dentada",
  "block.minecraft.banner.triangles_bottom.red": "Bas rossa dentada",
  "block.minecraft.banner.triangles_bottom.white": "Bas bianca dentada",
  "block.minecraft.banner.triangles_bottom.yellow": "Bas sgialda dentada",
  "block.minecraft.banner.triangles_top.black": "Capo negher dentad",
  "block.minecraft.banner.triangles_top.blue": "Capo bloeu dentad",
  "block.minecraft.banner.triangles_top.brown": "Capo marron dentad",
  "block.minecraft.banner.triangles_top.cyan": "Capo celest dentad",
  "block.minecraft.banner.triangles_top.gray": "Capo gris dentad",
  "block.minecraft.banner.triangles_top.green": "Capo verd dentad",
  "block.minecraft.banner.triangles_top.light_blue": "Capo bloeu ciar dentad",
  "block.minecraft.banner.triangles_top.light_gray": "Capo gris ciar dentad",
  "block.minecraft.banner.triangles_top.lime": "Capo lime dentad",
  "block.minecraft.banner.triangles_top.magenta": "Capo magenta dentad",
  "block.minecraft.banner.triangles_top.orange": "Capo naranz dentad",
  "block.minecraft.banner.triangles_top.pink": "Capo roeusa dentad",
  "block.minecraft.banner.triangles_top.purple": "Capo vioeula dentad",
  "block.minecraft.banner.triangles_top.red": "Capo ross dentad",
  "block.minecraft.banner.triangles_top.white": "Capo bianch dentad",
  "block.minecraft.banner.triangles_top.yellow": "Capo sgiald dentad",
  "block.minecraft.barrel": "Baril",
  "block.minecraft.barrier": "Bariera",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Far",
  "block.minecraft.beacon.primary": "Poder primari",
  "block.minecraft.beacon.secondary": "Poder segondari",
  "block.minecraft.bed.no_sleep": "Te poeudet dormì domà de nocc o in di temporai",
  "block.minecraft.bed.not_safe": "Adess te poeudet mìa possà; gh'è di moster chì arent",
  "block.minecraft.bed.obstructed": "Quell lecc chì l'è intralciad",
  "block.minecraft.bed.occupied": "Quell lecc chì l'è ocupad",
  "block.minecraft.bed.too_far_away": "Adess te poeudet mìa possà; el lecc l'è trop lontan",
  "block.minecraft.bedrock": "Preja del fond",
  "block.minecraft.bee_nest": "Bisoeul",
  "block.minecraft.beehive": "Avigg",
  "block.minecraft.beetroots": "Biedrave",
  "block.minecraft.bell": "Campana",
  "block.minecraft.big_dripleaf": "Foeuja-gota granda",
  "block.minecraft.big_dripleaf_stem": "Fust de foeuja-gota granda",
  "block.minecraft.birch_button": "Boton de biolla",
  "block.minecraft.birch_door": "Porta de biolla",
  "block.minecraft.birch_fence": "Stongarda de biolla",
  "block.minecraft.birch_fence_gate": "Restell de biolla",
  "block.minecraft.birch_hanging_sign": "Insegna de biolla",
  "block.minecraft.birch_leaves": "Foeuje de biolla",
  "block.minecraft.birch_log": "Bora de biolla",
  "block.minecraft.birch_planks": "Ass de biolla",
  "block.minecraft.birch_pressure_plate": "Pian a pression de biolla",
  "block.minecraft.birch_sapling": "But de biolla",
  "block.minecraft.birch_shelf": "Scaffale di betulla",
  "block.minecraft.birch_sign": "Cartell de biolla",
  "block.minecraft.birch_slab": "Pioda de biolla",
  "block.minecraft.birch_stairs": "Basei de biolla",
  "block.minecraft.birch_trapdoor": "Bussera de biolla",
  "block.minecraft.birch_wall_hanging_sign": "Insegna a mur de biolla",
  "block.minecraft.birch_wall_sign": "Cartell de mur de biolla",
  "block.minecraft.birch_wood": "Legn de biolla",
  "block.minecraft.black_banner": "Bandera negra",
  "block.minecraft.black_bed": "Lecc negher",
  "block.minecraft.black_candle": "Candira negra",
  "block.minecraft.black_candle_cake": "Torta con candila negra",
  "block.minecraft.black_carpet": "Tapet negher",
  "block.minecraft.black_concrete": "Ciment negher",
  "block.minecraft.black_concrete_powder": "Polver de ciment negra",
  "block.minecraft.black_glazed_terracotta": "Terracota smaltada negra",
  "block.minecraft.black_shulker_box": "Scatola de shulker negra",
  "block.minecraft.black_stained_glass": "Veder negher",
  "block.minecraft.black_stained_glass_pane": "Panell de veder negher",
  "block.minecraft.black_terracotta": "Terracota negra",
  "block.minecraft.black_wool": "Lana negra",
  "block.minecraft.blackstone": "Prejanegra",
  "block.minecraft.blackstone_slab": "Pioda de prejanegra",
  "block.minecraft.blackstone_stairs": "Basei de prejanegra",
  "block.minecraft.blackstone_wall": "Mur de prejanegra",
  "block.minecraft.blast_furnace": "Volt-forn",
  "block.minecraft.blue_banner": "Bandera bloeu",
  "block.minecraft.blue_bed": "Lecc bloeu",
  "block.minecraft.blue_candle": "Candira bloeu",
  "block.minecraft.blue_candle_cake": "Torta con candila bloeu",
  "block.minecraft.blue_carpet": "Tapet bloeu",
  "block.minecraft.blue_concrete": "Ciment bloeu",
  "block.minecraft.blue_concrete_powder": "Polver de ciment bloeu",
  "block.minecraft.blue_glazed_terracotta": "Terracota smaltada bloeu",
  "block.minecraft.blue_ice": "Giazz bloeu",
  "block.minecraft.blue_orchid": "Orchidea bloeu",
  "block.minecraft.blue_shulker_box": "Scatola de shulker bloeu",
  "block.minecraft.blue_stained_glass": "Veder bloeu",
  "block.minecraft.blue_stained_glass_pane": "Panell de veder bloeu",
  "block.minecraft.blue_terracotta": "Terracota bloeu",
  "block.minecraft.blue_wool": "Lana bloeu",
  "block.minecraft.bone_block": "Bloch de oss",
  "block.minecraft.bookshelf": "Libreria",
  "block.minecraft.brain_coral": "Corall a cervell",
  "block.minecraft.brain_coral_block": "Bloch de corall a cervell",
  "block.minecraft.brain_coral_fan": "Gorgonia a cervell",
  "block.minecraft.brain_coral_wall_fan": "Gorgonia a cervell a mur",
  "block.minecraft.brewing_stand": "Destillador",
  "block.minecraft.brick_slab": "Pioda de quadrei",
  "block.minecraft.brick_stairs": "Basei de quadrei",
  "block.minecraft.brick_wall": "Mur de quadrei",
  "block.minecraft.bricks": "Quadrei",
  "block.minecraft.brown_banner": "Bandera marrona",
  "block.minecraft.brown_bed": "Lecc marron",
  "block.minecraft.brown_candle": "Candira marrona",
  "block.minecraft.brown_candle_cake": "Torta con candila marrona",
  "block.minecraft.brown_carpet": "Tapet marron",
  "block.minecraft.brown_concrete": "Ciment marron",
  "block.minecraft.brown_concrete_powder": "Polver de ciment marrona",
  "block.minecraft.brown_glazed_terracotta": "Terracota smaltada marrona",
  "block.minecraft.brown_mushroom": "Fonsg marron",
  "block.minecraft.brown_mushroom_block": "Bloch de fonsg marron",
  "block.minecraft.brown_shulker_box": "Scatola de shulker marrona",
  "block.minecraft.brown_stained_glass": "Veder marron",
  "block.minecraft.brown_stained_glass_pane": "Panell de veder marron",
  "block.minecraft.brown_terracotta": "Terracota marrona",
  "block.minecraft.brown_wool": "Lana marrona",
  "block.minecraft.bubble_column": "Colona de balle",
  "block.minecraft.bubble_coral": "Corall a balle",
  "block.minecraft.bubble_coral_block": "Bloch de corall a balle",
  "block.minecraft.bubble_coral_fan": "Gorgonia a balle",
  "block.minecraft.bubble_coral_wall_fan": "Gorgonia a balle a mur",
  "block.minecraft.budding_amethyst": "Ametista che la cascia foeura i gemme",
  "block.minecraft.bush": "Arbusto",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Fiore di cactus",
  "block.minecraft.cake": "Torta",
  "block.minecraft.calcite": "Calcit",
  "block.minecraft.calibrated_sculk_sensor": "Sensore di sculk calibrato",
  "block.minecraft.campfire": "Falò",
  "block.minecraft.candle": "Candira",
  "block.minecraft.candle_cake": "Torta con candila",
  "block.minecraft.carrots": "Carotole",
  "block.minecraft.cartography_table": "Banch de cartografia",
  "block.minecraft.carved_pumpkin": "Zuca sigillada",
  "block.minecraft.cauldron": "Calderon",
  "block.minecraft.cave_air": "Aria di grote",
  "block.minecraft.cave_vines": "Ergna di crote",
  "block.minecraft.cave_vines_plant": "Pianta de la vid di caverne",
  "block.minecraft.chain": "Cadena",
  "block.minecraft.chain_command_block": "Bloch di comand a cadena",
  "block.minecraft.cherry_button": "Boton de scireser",
  "block.minecraft.cherry_door": "Porta de scireser",
  "block.minecraft.cherry_fence": "Stongarda de scireser",
  "block.minecraft.cherry_fence_gate": "Restell de scireser",
  "block.minecraft.cherry_hanging_sign": "Insegna de scireser",
  "block.minecraft.cherry_leaves": "Foeuje de scireser",
  "block.minecraft.cherry_log": "Bora de cireser",
  "block.minecraft.cherry_planks": "Ass de scireser",
  "block.minecraft.cherry_pressure_plate": "Pian a pression de scireser",
  "block.minecraft.cherry_sapling": "But de scireser",
  "block.minecraft.cherry_shelf": "Scaffale di ciliegio",
  "block.minecraft.cherry_sign": "Placard de scireser",
  "block.minecraft.cherry_slab": "Pioda de scireser",
  "block.minecraft.cherry_stairs": "Basei de scireser",
  "block.minecraft.cherry_trapdoor": "Bussera de scireser",
  "block.minecraft.cherry_wall_hanging_sign": "Insegna a mur de scireser",
  "block.minecraft.cherry_wall_sign": "Placard de mur de scireser",
  "block.minecraft.cherry_wood": "Legn de scireser",
  "block.minecraft.chest": "Cesta",
  "block.minecraft.chipped_anvil": "Incusgen sfrisada",
  "block.minecraft.chiseled_bookshelf": "Libreria sigillada",
  "block.minecraft.chiseled_copper": "Rame cesellato",
  "block.minecraft.chiseled_deepslate": "Lavagna profonda sigillada",
  "block.minecraft.chiseled_nether_bricks": "Quadrei del Nether sigillad",
  "block.minecraft.chiseled_polished_blackstone": "Prejanegra soliada sigillada",
  "block.minecraft.chiseled_quartz_block": "Bloch de quarz sigillad",
  "block.minecraft.chiseled_red_sandstone": "Molera rossa sigillada",
  "block.minecraft.chiseled_resin_bricks": "Mattoni di resina cesellati",
  "block.minecraft.chiseled_sandstone": "Molera sigillada",
  "block.minecraft.chiseled_stone_bricks": "Quadrei de preja sigillad",
  "block.minecraft.chiseled_tuff": "Tufo cesellato",
  "block.minecraft.chiseled_tuff_bricks": "Mattoni di tufo cesellati",
  "block.minecraft.chorus_flower": "Fior de chorus",
  "block.minecraft.chorus_plant": "Pianta de chorus",
  "block.minecraft.clay": "Terra creja",
  "block.minecraft.closed_eyeblossom": "Occhidea chiusa",
  "block.minecraft.coal_block": "Bloch de carbon",
  "block.minecraft.coal_ore": "Mineral de carbon",
  "block.minecraft.coarse_dirt": "Terra strasida",
  "block.minecraft.cobbled_deepslate": "Sass de lavagna profonda",
  "block.minecraft.cobbled_deepslate_slab": "Pioda de sass de lavagna profonda",
  "block.minecraft.cobbled_deepslate_stairs": "Basei de sass de lavagna profonda",
  "block.minecraft.cobbled_deepslate_wall": "Mur de sass de lavagna profonda",
  "block.minecraft.cobblestone": "Rizzoeui",
  "block.minecraft.cobblestone_slab": "Pioda de rizzoeui",
  "block.minecraft.cobblestone_stairs": "Basei de rizzoeui",
  "block.minecraft.cobblestone_wall": "Mur de rizzoeui",
  "block.minecraft.cobweb": "Ragnera",
  "block.minecraft.cocoa": "Cacao",
  "block.minecraft.command_block": "Bloch di comand",
  "block.minecraft.comparator": "Comparador de prejarossa",
  "block.minecraft.composter": "Compostera",
  "block.minecraft.conduit": "Condot",
  "block.minecraft.copper_bars": "Sbarre di rame",
  "block.minecraft.copper_block": "Bloch de ram",
  "block.minecraft.copper_bulb": "Lampada di rame",
  "block.minecraft.copper_chain": "Catena di rame",
  "block.minecraft.copper_chest": "Baule di rame",
  "block.minecraft.copper_door": "Porta di rame",
  "block.minecraft.copper_golem_statue": "Statua di golem di rame",
  "block.minecraft.copper_grate": "Grata di rame",
  "block.minecraft.copper_lantern": "Lanterna di rame",
  "block.minecraft.copper_ore": "Ram sgrezz",
  "block.minecraft.copper_torch": "Torcia di rame",
  "block.minecraft.copper_trapdoor": "Botola di rame",
  "block.minecraft.copper_wall_torch": "Torcia di rame a parete",
  "block.minecraft.cornflower": "Lori",
  "block.minecraft.cracked_deepslate_bricks": "Quadrei de lavagna profonda crep",
  "block.minecraft.cracked_deepslate_tiles": "Piastrelle de lavagna profonda crepe",
  "block.minecraft.cracked_nether_bricks": "Quadrei del Nether crep",
  "block.minecraft.cracked_polished_blackstone_bricks": "Quadrei de prejanegra soliada crep",
  "block.minecraft.cracked_stone_bricks": "Quadrei de preja crep",
  "block.minecraft.crafter": "Fabbricatore",
  "block.minecraft.crafting_table": "Banch de lavorà",
  "block.minecraft.creaking_heart": "Cuore di scricchio",
  "block.minecraft.creeper_head": "Coo de creeper",
  "block.minecraft.creeper_wall_head": "Coo de creeper de mur",
  "block.minecraft.crimson_button": "Boton cremes",
  "block.minecraft.crimson_door": "Porta cremesa",
  "block.minecraft.crimson_fence": "Stongarda cremes",
  "block.minecraft.crimson_fence_gate": "Restell cremes",
  "block.minecraft.crimson_fungus": "Fonsg cremes",
  "block.minecraft.crimson_hanging_sign": "Insegna cremes",
  "block.minecraft.crimson_hyphae": "Ife cremese",
  "block.minecraft.crimson_nylium": "Neceli cremes",
  "block.minecraft.crimson_planks": "Ass cremese",
  "block.minecraft.crimson_pressure_plate": "Pian a pression cremes",
  "block.minecraft.crimson_roots": "Radis cremes",
  "block.minecraft.crimson_shelf": "Scaffale cremisi",
  "block.minecraft.crimson_sign": "Cartell cremes",
  "block.minecraft.crimson_slab": "Pioda cremesa",
  "block.minecraft.crimson_stairs": "Basei cremes",
  "block.minecraft.crimson_stem": "Gamba cremesa",
  "block.minecraft.crimson_trapdoor": "Bussera cremesa",
  "block.minecraft.crimson_wall_hanging_sign": "Insegna a mur cremes",
  "block.minecraft.crimson_wall_sign": "Cartell de mur cremes",
  "block.minecraft.crying_obsidian": "Ossidiana caragnenta",
  "block.minecraft.cut_copper": "Ram tajad",
  "block.minecraft.cut_copper_slab": "Pioda de ram tajad",
  "block.minecraft.cut_copper_stairs": "Basei de ram tajad",
  "block.minecraft.cut_red_sandstone": "Molera rossa tajada",
  "block.minecraft.cut_red_sandstone_slab": "Pioda de molera rossa tajada",
  "block.minecraft.cut_sandstone": "Molera tajada",
  "block.minecraft.cut_sandstone_slab": "Pioda de molera tajada",
  "block.minecraft.cyan_banner": "Bandera celesta",
  "block.minecraft.cyan_bed": "Lecc celest",
  "block.minecraft.cyan_candle": "Candira celesta",
  "block.minecraft.cyan_candle_cake": "Torta con candila ciana",
  "block.minecraft.cyan_carpet": "Tapet celest",
  "block.minecraft.cyan_concrete": "Ciment celest",
  "block.minecraft.cyan_concrete_powder": "Polver de ciment celesta",
  "block.minecraft.cyan_glazed_terracotta": "Terracota smaltada celesta",
  "block.minecraft.cyan_shulker_box": "Scatola de shulker celesta",
  "block.minecraft.cyan_stained_glass": "Veder celest",
  "block.minecraft.cyan_stained_glass_pane": "Panell de veder celest",
  "block.minecraft.cyan_terracotta": "Terracota celesta",
  "block.minecraft.cyan_wool": "Lana celesta",
  "block.minecraft.damaged_anvil": "Incusgen strapellada",
  "block.minecraft.dandelion": "Bofanella",
  "block.minecraft.dark_oak_button": "Boton de rogora",
  "block.minecraft.dark_oak_door": "Porta de rogora",
  "block.minecraft.dark_oak_fence": "Stongarda de rogora",
  "block.minecraft.dark_oak_fence_gate": "Restell de rogora",
  "block.minecraft.dark_oak_hanging_sign": "Insegna de rogora",
  "block.minecraft.dark_oak_leaves": "Foeuje de rogora",
  "block.minecraft.dark_oak_log": "Bora de rogora",
  "block.minecraft.dark_oak_planks": "Ass de rogora",
  "block.minecraft.dark_oak_pressure_plate": "Pian a pression de rogora",
  "block.minecraft.dark_oak_sapling": "But de rogora",
  "block.minecraft.dark_oak_shelf": "Scaffale di quercia scura",
  "block.minecraft.dark_oak_sign": "Cartell de rogora",
  "block.minecraft.dark_oak_slab": "Pioda de rogora",
  "block.minecraft.dark_oak_stairs": "Basei de rogora",
  "block.minecraft.dark_oak_trapdoor": "Bussera de rogora",
  "block.minecraft.dark_oak_wall_hanging_sign": "Insegna a mur de rogora",
  "block.minecraft.dark_oak_wall_sign": "Cartell de mur de rogora",
  "block.minecraft.dark_oak_wood": "Legn de rogora",
  "block.minecraft.dark_prismarine": "Prismarina scura",
  "block.minecraft.dark_prismarine_slab": "Pioda de prismarina scura",
  "block.minecraft.dark_prismarine_stairs": "Basei de prismarina scura",
  "block.minecraft.daylight_detector": "Rilevador del sol",
  "block.minecraft.dead_brain_coral": "Corall a cervell mort",
  "block.minecraft.dead_brain_coral_block": "Bloch de corall a cervell mort",
  "block.minecraft.dead_brain_coral_fan": "Gorgonia a cervell morta",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgonia a cervell morta a mur",
  "block.minecraft.dead_bubble_coral": "Corall a balle mort",
  "block.minecraft.dead_bubble_coral_block": "Bloch de corall a balle mort",
  "block.minecraft.dead_bubble_coral_fan": "Gorgonia a balle morta",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgonia a balle morta a mur",
  "block.minecraft.dead_bush": "Pianta seca",
  "block.minecraft.dead_fire_coral": "Corall de foeugh mort",
  "block.minecraft.dead_fire_coral_block": "Bloch de corall de foeugh mort",
  "block.minecraft.dead_fire_coral_fan": "Gorgonia de foeugh morta",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgonia de foeugh morta a mur",
  "block.minecraft.dead_horn_coral": "Corall a corna mort",
  "block.minecraft.dead_horn_coral_block": "Bloch de corall a corna mort",
  "block.minecraft.dead_horn_coral_fan": "Gorgonia a corna morta",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgonia a corna morta a mur",
  "block.minecraft.dead_tube_coral": "Corall a tubo mort",
  "block.minecraft.dead_tube_coral_block": "Bloch de corall a tubo mort",
  "block.minecraft.dead_tube_coral_fan": "Gorgonia a tubo morta",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgonia a tubo morta a mur",
  "block.minecraft.decorated_pot": "Vas decorad",
  "block.minecraft.deepslate": "Lavagna profonda",
  "block.minecraft.deepslate_brick_slab": "Pioda de quadrei de lavagna profonda",
  "block.minecraft.deepslate_brick_stairs": "Basei de quadrei de lavagna profonda",
  "block.minecraft.deepslate_brick_wall": "Mur de quadrei de lavagna profonda",
  "block.minecraft.deepslate_bricks": "Quadrei de lavagna profonda",
  "block.minecraft.deepslate_coal_ore": "Carbon sgresg in lavagna profonda",
  "block.minecraft.deepslate_copper_ore": "Ram sgresg in lavagna profonda",
  "block.minecraft.deepslate_diamond_ore": "Diamant sgresg in lavagna profonda",
  "block.minecraft.deepslate_emerald_ore": "Smerald sgresg in lavagna profonda",
  "block.minecraft.deepslate_gold_ore": "Or sgresg in lavagna profonda",
  "block.minecraft.deepslate_iron_ore": "Ferr sgresg in lavagna profonda",
  "block.minecraft.deepslate_lapis_ore": "Lapislazzer sgresg in lavagna profonda",
  "block.minecraft.deepslate_redstone_ore": "Preja rossa sgresgia in lavagna profonda",
  "block.minecraft.deepslate_tile_slab": "Pioda de piastrelle de lavagna profonda",
  "block.minecraft.deepslate_tile_stairs": "Basei de piastrelle de lavagna profonda",
  "block.minecraft.deepslate_tile_wall": "Mur de piastrelle de lavagna profonda",
  "block.minecraft.deepslate_tiles": "Piastrelle de lavagna profonda",
  "block.minecraft.detector_rail": "Binari relevador",
  "block.minecraft.diamond_block": "Bloch de diamant",
  "block.minecraft.diamond_ore": "Mineral de diamant",
  "block.minecraft.diorite": "Serizz",
  "block.minecraft.diorite_slab": "Pioda de serizz",
  "block.minecraft.diorite_stairs": "Basei de serizz",
  "block.minecraft.diorite_wall": "Mur de serizz",
  "block.minecraft.dirt": "Terra",
  "block.minecraft.dirt_path": "Senter voncc",
  "block.minecraft.dispenser": "Scompartidor",
  "block.minecraft.dragon_egg": "Oeuv de dragon",
  "block.minecraft.dragon_head": "Coo de dragon",
  "block.minecraft.dragon_wall_head": "Coo de dragon de mur",
  "block.minecraft.dried_ghast": "Ghast essiccato",
  "block.minecraft.dried_kelp_block": "Bloch de alghe seche",
  "block.minecraft.dripstone_block": "Bloch de speleotema",
  "block.minecraft.dropper": "Lassador",
  "block.minecraft.emerald_block": "Bloch de smerald",
  "block.minecraft.emerald_ore": "Mineral de smerald",
  "block.minecraft.enchanting_table": "Banch de instriament",
  "block.minecraft.end_gateway": "Entrada a l'End",
  "block.minecraft.end_portal": "Portal de l'End",
  "block.minecraft.end_portal_frame": "Telar del portal de l'End",
  "block.minecraft.end_rod": "Barra de l'End",
  "block.minecraft.end_stone": "Preja del Bord",
  "block.minecraft.end_stone_brick_slab": "Pioda de quadrei de preja de l'End",
  "block.minecraft.end_stone_brick_stairs": "Basei de quadrei de preja de l'End",
  "block.minecraft.end_stone_brick_wall": "Mur de quadrei de preja de l'End",
  "block.minecraft.end_stone_bricks": "Quadrei de preja de l'End",
  "block.minecraft.ender_chest": "Cesta de l'End",
  "block.minecraft.exposed_chiseled_copper": "Rame cesellato esposto",
  "block.minecraft.exposed_copper": "Ram espost",
  "block.minecraft.exposed_copper_bars": "Sbarre di rame esposto",
  "block.minecraft.exposed_copper_bulb": "Lampada di rame esposto",
  "block.minecraft.exposed_copper_chain": "Catena di rame esposto",
  "block.minecraft.exposed_copper_chest": "Baule di rame esposto",
  "block.minecraft.exposed_copper_door": "Porta di rame esposto",
  "block.minecraft.exposed_copper_golem_statue": "Statua di golem di rame esposto",
  "block.minecraft.exposed_copper_grate": "Grata di rame esposto",
  "block.minecraft.exposed_copper_lantern": "Lanterna di rame esposto",
  "block.minecraft.exposed_copper_trapdoor": "Botola di rame esposto",
  "block.minecraft.exposed_cut_copper": "Ram tajad espost",
  "block.minecraft.exposed_cut_copper_slab": "Pioda de ram tajad espost",
  "block.minecraft.exposed_cut_copper_stairs": "Basei de ram tajad espost",
  "block.minecraft.exposed_lightning_rod": "Parafulmine esposto",
  "block.minecraft.farmland": "Terra de somenà",
  "block.minecraft.fern": "Files",
  "block.minecraft.fire": "Foeugh",
  "block.minecraft.fire_coral": "Corall de foeugh",
  "block.minecraft.fire_coral_block": "Bloch de corall de foeugh",
  "block.minecraft.fire_coral_fan": "Gorgonia de foeugh",
  "block.minecraft.fire_coral_wall_fan": "Gorgonia de foeugh a mur",
  "block.minecraft.firefly_bush": "Cespuglio di lucciole",
  "block.minecraft.fletching_table": "Banch di flizze",
  "block.minecraft.flower_pot": "Vas de fior",
  "block.minecraft.flowering_azalea": "Azalea fiorida",
  "block.minecraft.flowering_azalea_leaves": "Foeuje de azalea fioride",
  "block.minecraft.frogspawn": "Oeuv de rana",
  "block.minecraft.frosted_ice": "Giazz dur",
  "block.minecraft.furnace": "Fornas",
  "block.minecraft.gilded_blackstone": "Prejanegra d'ora",
  "block.minecraft.glass": "Veder",
  "block.minecraft.glass_pane": "Panell de veder",
  "block.minecraft.glow_lichen": "Lichen sberlusent",
  "block.minecraft.glowstone": "Preja lusenta",
  "block.minecraft.gold_block": "Bloch d'or",
  "block.minecraft.gold_ore": "Mineral d'or",
  "block.minecraft.golden_dandelion": "Dente di leone d'oro",
  "block.minecraft.granite": "Miaroeul",
  "block.minecraft.granite_slab": "Pioda de miaroeul",
  "block.minecraft.granite_stairs": "Basei de miaroeul",
  "block.minecraft.granite_wall": "Mur de miaroeul",
  "block.minecraft.grass": "Erba",
  "block.minecraft.grass_block": "Erba",
  "block.minecraft.gravel": "Gera",
  "block.minecraft.gray_banner": "Bandera grisa",
  "block.minecraft.gray_bed": "Lecc gris",
  "block.minecraft.gray_candle": "Candira grisa",
  "block.minecraft.gray_candle_cake": "Torta con candila grisa",
  "block.minecraft.gray_carpet": "Tapet gris",
  "block.minecraft.gray_concrete": "Ciment gris",
  "block.minecraft.gray_concrete_powder": "Polver de ciment grisa",
  "block.minecraft.gray_glazed_terracotta": "Terracota smaltada grisa",
  "block.minecraft.gray_shulker_box": "Scatola de shulker grisa",
  "block.minecraft.gray_stained_glass": "Veder gris",
  "block.minecraft.gray_stained_glass_pane": "Panell de veder gris",
  "block.minecraft.gray_terracotta": "Terracota grisa",
  "block.minecraft.gray_wool": "Lana grisa",
  "block.minecraft.green_banner": "Bandera verda",
  "block.minecraft.green_bed": "Lecc verd",
  "block.minecraft.green_candle": "Candira verda",
  "block.minecraft.green_candle_cake": "Torta con candila verda",
  "block.minecraft.green_carpet": "Tapet verd",
  "block.minecraft.green_concrete": "Ciment verd",
  "block.minecraft.green_concrete_powder": "Polver de ciment verda",
  "block.minecraft.green_glazed_terracotta": "Terracota smaltada verda",
  "block.minecraft.green_shulker_box": "Scatola de shulker verda",
  "block.minecraft.green_stained_glass": "Veder verd",
  "block.minecraft.green_stained_glass_pane": "Panell de veder verd",
  "block.minecraft.green_terracotta": "Terracota verda",
  "block.minecraft.green_wool": "Lana verda",
  "block.minecraft.grindstone": "Moeula",
  "block.minecraft.hanging_roots": "Radis a bandolera",
  "block.minecraft.hay_block": "Balla de fen",
  "block.minecraft.heavy_core": "Nucleo pesante",
  "block.minecraft.heavy_weighted_pressure_plate": "Pian a pression per pes grand",
  "block.minecraft.honey_block": "Bloch de mel",
  "block.minecraft.honeycomb_block": "Bloch de beden",
  "block.minecraft.hopper": "Tremoeusgia",
  "block.minecraft.horn_coral": "Corall a corna",
  "block.minecraft.horn_coral_block": "Bloch de corall a corna",
  "block.minecraft.horn_coral_fan": "Gorgonia a corna",
  "block.minecraft.horn_coral_wall_fan": "Gorgonia a corna a mur",
  "block.minecraft.ice": "Giazz",
  "block.minecraft.infested_chiseled_stone_bricks": "Quadrei de preja sigillad infestad",
  "block.minecraft.infested_cobblestone": "Rizzoeui infestad",
  "block.minecraft.infested_cracked_stone_bricks": "Quadrei de preja crep infestad",
  "block.minecraft.infested_deepslate": "Lavagna profonda infestada",
  "block.minecraft.infested_mossy_stone_bricks": "Quadrei de preja tepos infestad",
  "block.minecraft.infested_stone": "Preja infestada",
  "block.minecraft.infested_stone_bricks": "Quadrei de preja infestad",
  "block.minecraft.iron_bars": "Sbarre de ferr",
  "block.minecraft.iron_block": "Bloch de ferr",
  "block.minecraft.iron_chain": "Catena di ferro",
  "block.minecraft.iron_door": "Porta de ferr",
  "block.minecraft.iron_ore": "Mineral de ferr",
  "block.minecraft.iron_trapdoor": "Bussera de ferr",
  "block.minecraft.jack_o_lantern": "Lanterna de zuca",
  "block.minecraft.jigsaw": "Bloch puzzle",
  "block.minecraft.jukebox": "Sgira-disch",
  "block.minecraft.jungle_button": "Boton de la sgiungla",
  "block.minecraft.jungle_door": "Porta de la sgiungla",
  "block.minecraft.jungle_fence": "Stongarda de la sgiungla",
  "block.minecraft.jungle_fence_gate": "Restell de la sgiungla",
  "block.minecraft.jungle_hanging_sign": "Insegna de la sgiungla",
  "block.minecraft.jungle_leaves": "Foeuje de la sgiungla",
  "block.minecraft.jungle_log": "Bora de la giungla",
  "block.minecraft.jungle_planks": "Ass de la sgiungla",
  "block.minecraft.jungle_pressure_plate": "Pian a pression de la sgiungla",
  "block.minecraft.jungle_sapling": "But de la sgiungla",
  "block.minecraft.jungle_shelf": "Scaffale della giungla",
  "block.minecraft.jungle_sign": "Cartell de la sgiungla",
  "block.minecraft.jungle_slab": "Pioda de la sgiungla",
  "block.minecraft.jungle_stairs": "Basei de la sgiungla",
  "block.minecraft.jungle_trapdoor": "Bussera de la sgiungla",
  "block.minecraft.jungle_wall_hanging_sign": "Insegna a mur de la sgiungla",
  "block.minecraft.jungle_wall_sign": "Cartell de mur de la sgiungla",
  "block.minecraft.jungle_wood": "Legn de la giungla",
  "block.minecraft.kelp": "Alga",
  "block.minecraft.kelp_plant": "Picol d'alga",
  "block.minecraft.ladder": "Scala a man",
  "block.minecraft.lantern": "Lanterna",
  "block.minecraft.lapis_block": "Bloch de lapis lazuli",
  "block.minecraft.lapis_ore": "Mineral de lapislazzer",
  "block.minecraft.large_amethyst_bud": "Gemma de ametista granda",
  "block.minecraft.large_fern": "Files gigant",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Calderon de lava",
  "block.minecraft.leaf_litter": "Fogliame",
  "block.minecraft.lectern": "Letorin",
  "block.minecraft.lever": "Leva",
  "block.minecraft.light": "Lus",
  "block.minecraft.light_blue_banner": "Bandera bloeu ciar",
  "block.minecraft.light_blue_bed": "Lecc bloeu ciar",
  "block.minecraft.light_blue_candle": "Candira bloeu ciara",
  "block.minecraft.light_blue_candle_cake": "Torta con candila celesta",
  "block.minecraft.light_blue_carpet": "Tapet bloeu ciar",
  "block.minecraft.light_blue_concrete": "Ciment bloeu ciar",
  "block.minecraft.light_blue_concrete_powder": "Polver de ciment bloeu ciar",
  "block.minecraft.light_blue_glazed_terracotta": "Terracota smaltada bloeu ciar",
  "block.minecraft.light_blue_shulker_box": "Scatola de shulker bloeu ciar",
  "block.minecraft.light_blue_stained_glass": "Veder bloeu ciar",
  "block.minecraft.light_blue_stained_glass_pane": "Panell de veder bloeu ciar",
  "block.minecraft.light_blue_terracotta": "Terracota bloeu ciar",
  "block.minecraft.light_blue_wool": "Lana bloeu ciar",
  "block.minecraft.light_gray_banner": "Bandera grisa ciar",
  "block.minecraft.light_gray_bed": "Lecc gris ciar",
  "block.minecraft.light_gray_candle": "Candira grisa ciara",
  "block.minecraft.light_gray_candle_cake": "Torta con candile grisa ciara",
  "block.minecraft.light_gray_carpet": "Tapet gris ciar",
  "block.minecraft.light_gray_concrete": "Ciment gris ciar",
  "block.minecraft.light_gray_concrete_powder": "Polver de ciment grisa ciar",
  "block.minecraft.light_gray_glazed_terracotta": "Terracota smaltada grisa ciar",
  "block.minecraft.light_gray_shulker_box": "Scatola de shulker grisa ciar",
  "block.minecraft.light_gray_stained_glass": "Veder gris ciar",
  "block.minecraft.light_gray_stained_glass_pane": "Panell de veder gris ciar",
  "block.minecraft.light_gray_terracotta": "Terracota grisa ciar",
  "block.minecraft.light_gray_wool": "Lana grisa ciar",
  "block.minecraft.light_weighted_pressure_plate": "Pian a pression per pes piscinin",
  "block.minecraft.lightning_rod": "Parasaete",
  "block.minecraft.lilac": "Lilà",
  "block.minecraft.lily_of_the_valley": "Moneghin",
  "block.minecraft.lily_pad": "Lavedon",
  "block.minecraft.lime_banner": "Bandera lime",
  "block.minecraft.lime_bed": "Lecc lime",
  "block.minecraft.lime_candle": "Candira lime",
  "block.minecraft.lime_candle_cake": "Torta con candila lime",
  "block.minecraft.lime_carpet": "Tapet lime",
  "block.minecraft.lime_concrete": "Ciment lime",
  "block.minecraft.lime_concrete_powder": "Polver de ciment lime",
  "block.minecraft.lime_glazed_terracotta": "Terracota smaltada lime",
  "block.minecraft.lime_shulker_box": "Scatola de shulker lime",
  "block.minecraft.lime_stained_glass": "Veder lime",
  "block.minecraft.lime_stained_glass_pane": "Panell de veder lime",
  "block.minecraft.lime_terracotta": "Terracota lime",
  "block.minecraft.lime_wool": "Lana lime",
  "block.minecraft.lodestone": "Magnetit",
  "block.minecraft.loom": "Telar",
  "block.minecraft.magenta_banner": "Bandera magenta",
  "block.minecraft.magenta_bed": "Lecc magenta",
  "block.minecraft.magenta_candle": "Candira magenta",
  "block.minecraft.magenta_candle_cake": "Torta con candila magenta",
  "block.minecraft.magenta_carpet": "Tapet magenta",
  "block.minecraft.magenta_concrete": "Ciment magenta",
  "block.minecraft.magenta_concrete_powder": "Polver de ciment magenta",
  "block.minecraft.magenta_glazed_terracotta": "Terracota smaltada magenta",
  "block.minecraft.magenta_shulker_box": "Scatola de shulker magenta",
  "block.minecraft.magenta_stained_glass": "Veder magenta",
  "block.minecraft.magenta_stained_glass_pane": "Panell de veder magenta",
  "block.minecraft.magenta_terracotta": "Terracota magenta",
  "block.minecraft.magenta_wool": "Lana magenta",
  "block.minecraft.magma_block": "Bloch de magma",
  "block.minecraft.mangrove_button": "Boton de mangrovia",
  "block.minecraft.mangrove_door": "Porta de mangrovia",
  "block.minecraft.mangrove_fence": "Stongarda de mangrovia",
  "block.minecraft.mangrove_fence_gate": "Restell de mangrovia",
  "block.minecraft.mangrove_hanging_sign": "Insegna de mangrovia",
  "block.minecraft.mangrove_leaves": "Foeuje de mangrovia",
  "block.minecraft.mangrove_log": "Bora de mangrovia",
  "block.minecraft.mangrove_planks": "Ass de mangrovia",
  "block.minecraft.mangrove_pressure_plate": "Pian a pression de mangrovia",
  "block.minecraft.mangrove_propagule": "Propapagul de mangrovia",
  "block.minecraft.mangrove_roots": "Radis de mangrovia",
  "block.minecraft.mangrove_shelf": "Scaffale di mangrovia",
  "block.minecraft.mangrove_sign": "Cartell de mangrovia",
  "block.minecraft.mangrove_slab": "Pioda de mangrovia",
  "block.minecraft.mangrove_stairs": "Basei de mangrovia",
  "block.minecraft.mangrove_trapdoor": "Bussera de mangrovia",
  "block.minecraft.mangrove_wall_hanging_sign": "Insegna a mur de mangrovia",
  "block.minecraft.mangrove_wall_sign": "Cartell de mur de mangrovia",
  "block.minecraft.mangrove_wood": "Legn de mangrovia",
  "block.minecraft.medium_amethyst_bud": "Gemma de ametista media",
  "block.minecraft.melon": "Inguria",
  "block.minecraft.melon_stem": "Pianta de inguria",
  "block.minecraft.moss_block": "Bloch de tepa",
  "block.minecraft.moss_carpet": "Taped de tepa",
  "block.minecraft.mossy_cobblestone": "Bloch de rizzoeui tepos",
  "block.minecraft.mossy_cobblestone_slab": "Pioda de rizzoeui tepos",
  "block.minecraft.mossy_cobblestone_stairs": "Basei de rizzoeui tepos",
  "block.minecraft.mossy_cobblestone_wall": "Mur de rizzoeui tepos",
  "block.minecraft.mossy_stone_brick_slab": "Pioda de quadrei de preja tepos",
  "block.minecraft.mossy_stone_brick_stairs": "Basei de quadrei de preja tepos",
  "block.minecraft.mossy_stone_brick_wall": "Mur de quadrei de preja tepos",
  "block.minecraft.mossy_stone_bricks": "Quadrei de preja tepos",
  "block.minecraft.moving_piston": "Piston in moviment",
  "block.minecraft.mud": "Palta",
  "block.minecraft.mud_brick_slab": "Pioda de quadrei de palta",
  "block.minecraft.mud_brick_stairs": "Basei de quadrei de palta",
  "block.minecraft.mud_brick_wall": "Mur de quadrei de palta",
  "block.minecraft.mud_bricks": "Quadrei de palta",
  "block.minecraft.muddy_mangrove_roots": "Radis paltuscent de mangrovia",
  "block.minecraft.mushroom_stem": "Picol de fonsg",
  "block.minecraft.mycelium": "Miceli",
  "block.minecraft.nether_brick_fence": "Stongarda de quadrei del Nether",
  "block.minecraft.nether_brick_slab": "Pioda de quadrei del Nether",
  "block.minecraft.nether_brick_stairs": "Basei de quadrei del Nether",
  "block.minecraft.nether_brick_wall": "Mur de quadrei del Nether",
  "block.minecraft.nether_bricks": "Quadrei del Nether",
  "block.minecraft.nether_gold_ore": "Mineral d'or del Nether",
  "block.minecraft.nether_portal": "Porta del Nether",
  "block.minecraft.nether_quartz_ore": "Mineral de quarz del Nether",
  "block.minecraft.nether_sprouts": "But del Nether",
  "block.minecraft.nether_wart": "Brossera del Nether",
  "block.minecraft.nether_wart_block": "Bloch de brossere del Nether",
  "block.minecraft.netherite_block": "Bloch de netherite",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloch sonador",
  "block.minecraft.oak_button": "Boton de cerr",
  "block.minecraft.oak_door": "Porta de cerr",
  "block.minecraft.oak_fence": "Stongarda de cerr",
  "block.minecraft.oak_fence_gate": "Restell de cerr",
  "block.minecraft.oak_hanging_sign": "Insegna de cerr",
  "block.minecraft.oak_leaves": "Foeuje de cerr",
  "block.minecraft.oak_log": "Bora de cerr",
  "block.minecraft.oak_planks": "Ass de cerr",
  "block.minecraft.oak_pressure_plate": "Pian a pression de cerr",
  "block.minecraft.oak_sapling": "But de cerr",
  "block.minecraft.oak_shelf": "Scaffale di quercia",
  "block.minecraft.oak_sign": "Cartell de cerr",
  "block.minecraft.oak_slab": "Pioda de cerr",
  "block.minecraft.oak_stairs": "Basei de cerr",
  "block.minecraft.oak_trapdoor": "Bussera de cerr",
  "block.minecraft.oak_wall_hanging_sign": "Insegna a mur de cerr",
  "block.minecraft.oak_wall_sign": "Cartell de mur de cerr",
  "block.minecraft.oak_wood": "Legn de cerr",
  "block.minecraft.observer": "Osservador",
  "block.minecraft.obsidian": "Ossidiana",
  "block.minecraft.ochre_froglight": "Rana-lus ocra",
  "block.minecraft.ominous_banner": "Bandera de la deslipa",
  "block.minecraft.open_eyeblossom": "Occhidea aperta",
  "block.minecraft.orange_banner": "Bandera naranza",
  "block.minecraft.orange_bed": "Lecc naranz",
  "block.minecraft.orange_candle": "Candira naranza",
  "block.minecraft.orange_candle_cake": "Torta con candila naranza",
  "block.minecraft.orange_carpet": "Tapet naranz",
  "block.minecraft.orange_concrete": "Ciment naranz",
  "block.minecraft.orange_concrete_powder": "Polver de ciment naranz",
  "block.minecraft.orange_glazed_terracotta": "Terracota smaltada naranza",
  "block.minecraft.orange_shulker_box": "Scatola de shulker naranza",
  "block.minecraft.orange_stained_glass": "Veder naranz",
  "block.minecraft.orange_stained_glass_pane": "Panell de veder naranz",
  "block.minecraft.orange_terracotta": "Terracota naranza",
  "block.minecraft.orange_tulip": "Tolipan naranz",
  "block.minecraft.orange_wool": "Lana naranza",
  "block.minecraft.oxeye_daisy": "Margherita",
  "block.minecraft.oxidized_chiseled_copper": "Rame cesellato ossidato",
  "block.minecraft.oxidized_copper": "Ram ossidad",
  "block.minecraft.oxidized_copper_bars": "Sbarre di rame ossidato",
  "block.minecraft.oxidized_copper_bulb": "Lampada di rame ossidato",
  "block.minecraft.oxidized_copper_chain": "Catena di rame ossidato",
  "block.minecraft.oxidized_copper_chest": "Baule di rame ossidato",
  "block.minecraft.oxidized_copper_door": "Porta di rame ossidato",
  "block.minecraft.oxidized_copper_golem_statue": "Statua di golem di rame ossidato",
  "block.minecraft.oxidized_copper_grate": "Grata di rame ossidato",
  "block.minecraft.oxidized_copper_lantern": "Lanterna di rame ossidato",
  "block.minecraft.oxidized_copper_trapdoor": "Botola di rame ossidato",
  "block.minecraft.oxidized_cut_copper": "Ram tajad ossidad",
  "block.minecraft.oxidized_cut_copper_slab": "Pioda de ram tajad ossidad",
  "block.minecraft.oxidized_cut_copper_stairs": "Basei de ram tajad ossidad",
  "block.minecraft.oxidized_lightning_rod": "Parafulmine ossidato",
  "block.minecraft.packed_ice": "Giazz compat",
  "block.minecraft.packed_mud": "Palta compata",
  "block.minecraft.pale_hanging_moss": "Muschio pendente pallido",
  "block.minecraft.pale_moss_block": "Blocco di muschio pallido",
  "block.minecraft.pale_moss_carpet": "Tappeto di muschio pallido",
  "block.minecraft.pale_oak_button": "Pulsante di quercia pallida",
  "block.minecraft.pale_oak_door": "Porta di quercia pallida",
  "block.minecraft.pale_oak_fence": "Staccionata di quercia pallida",
  "block.minecraft.pale_oak_fence_gate": "Cancelletto di quercia pallida",
  "block.minecraft.pale_oak_hanging_sign": "Insegna di quercia pallida",
  "block.minecraft.pale_oak_leaves": "Foglie di quercia pallida",
  "block.minecraft.pale_oak_log": "Bora de cerr slavi",
  "block.minecraft.pale_oak_planks": "Assi di quercia pallida",
  "block.minecraft.pale_oak_pressure_plate": "Pedana a pressione di quercia pallida",
  "block.minecraft.pale_oak_sapling": "Arboscello di quercia pallida",
  "block.minecraft.pale_oak_shelf": "Scaffale di quercia pallida",
  "block.minecraft.pale_oak_sign": "Cartello di quercia pallida",
  "block.minecraft.pale_oak_slab": "Lastra di quercia pallida",
  "block.minecraft.pale_oak_stairs": "Scalini di quercia pallida",
  "block.minecraft.pale_oak_trapdoor": "Botola di quercia pallida",
  "block.minecraft.pale_oak_wall_hanging_sign": "Insegna di quercia pallida a parete",
  "block.minecraft.pale_oak_wall_sign": "Cartello di quercia pallida a parete",
  "block.minecraft.pale_oak_wood": "Legno di quercia pallida",
  "block.minecraft.pearlescent_froglight": "Rana-lus color perla",
  "block.minecraft.peony": "Peonia",
  "block.minecraft.petrified_oak_slab": "Pioda de cerr de preja",
  "block.minecraft.piglin_head": "Coo de piglin",
  "block.minecraft.piglin_wall_head": "Coo de piglin de mur",
  "block.minecraft.pink_banner": "Bandera roeusa",
  "block.minecraft.pink_bed": "Lecc roeusa",
  "block.minecraft.pink_candle": "Candira roeusa",
  "block.minecraft.pink_candle_cake": "Torta con candila roeusa",
  "block.minecraft.pink_carpet": "Tapet roeusa",
  "block.minecraft.pink_concrete": "Ciment roeusa",
  "block.minecraft.pink_concrete_powder": "Polver de ciment roeusa",
  "block.minecraft.pink_glazed_terracotta": "Terracota smaltada roeusa",
  "block.minecraft.pink_petals": "Petali rosa",
  "block.minecraft.pink_shulker_box": "Scatola de shulker roeusa",
  "block.minecraft.pink_stained_glass": "Veder roeusa",
  "block.minecraft.pink_stained_glass_pane": "Panell de veder roeusa",
  "block.minecraft.pink_terracotta": "Terracota roeusa",
  "block.minecraft.pink_tulip": "Tolipan roeusa",
  "block.minecraft.pink_wool": "Lana roeusa",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Coo de piston",
  "block.minecraft.pitcher_crop": "Coltura di pianta carnivora",
  "block.minecraft.pitcher_plant": "Pianta carnivora",
  "block.minecraft.player_head": "Coo de sgiugador",
  "block.minecraft.player_head.named": "Coo del %s",
  "block.minecraft.player_wall_head": "Coo de sgiugador de mur",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Speleotema guzz",
  "block.minecraft.polished_andesite": "Andesit soliada",
  "block.minecraft.polished_andesite_slab": "Pioda de andesit soliada",
  "block.minecraft.polished_andesite_stairs": "Basei de andesit soliada",
  "block.minecraft.polished_basalt": "Basalt soliad",
  "block.minecraft.polished_blackstone": "Prejanegra soliada",
  "block.minecraft.polished_blackstone_brick_slab": "Pioda de quadrei de prejanegra soliada",
  "block.minecraft.polished_blackstone_brick_stairs": "Basei de quadrei de prejanegra soliada",
  "block.minecraft.polished_blackstone_brick_wall": "Mur de quadrei de prejanegra soliada",
  "block.minecraft.polished_blackstone_bricks": "Quadrei de prejanegra soliada",
  "block.minecraft.polished_blackstone_button": "Boton de prejanegra soliada",
  "block.minecraft.polished_blackstone_pressure_plate": "Pian a pression de prejanegra soliada",
  "block.minecraft.polished_blackstone_slab": "Pioda de prejanegra soliada",
  "block.minecraft.polished_blackstone_stairs": "Basei de prejanegra soliada",
  "block.minecraft.polished_blackstone_wall": "Mur de prejanegra soliada",
  "block.minecraft.polished_deepslate": "Lavagna profonda soliada",
  "block.minecraft.polished_deepslate_slab": "Pioda de lavagna profonda soliada",
  "block.minecraft.polished_deepslate_stairs": "Basei de lavagna profonda soliada",
  "block.minecraft.polished_deepslate_wall": "Mur de lavagna profonda soliada",
  "block.minecraft.polished_diorite": "Serizz soliad",
  "block.minecraft.polished_diorite_slab": "Pioda de serizz soliad",
  "block.minecraft.polished_diorite_stairs": "Basei de serizz soliad",
  "block.minecraft.polished_granite": "Miaroeul soliad",
  "block.minecraft.polished_granite_slab": "Pioda de miaroeul soliad",
  "block.minecraft.polished_granite_stairs": "Basei de miaroeul soliad",
  "block.minecraft.polished_tuff": "Tufo levigato",
  "block.minecraft.polished_tuff_slab": "Lastra di tufo levigato",
  "block.minecraft.polished_tuff_stairs": "Scalini di tufo levigato",
  "block.minecraft.polished_tuff_wall": "Muretto di tufo levigato",
  "block.minecraft.poppy": "Popolana",
  "block.minecraft.potatoes": "Pom de terra",
  "block.minecraft.potted_acacia_sapling": "Vas con but de rubinia",
  "block.minecraft.potted_allium": "Vas con fior de ai",
  "block.minecraft.potted_azalea_bush": "Vas con azalea",
  "block.minecraft.potted_azure_bluet": "Vas con houstonia",
  "block.minecraft.potted_bamboo": "Vas con bamboo",
  "block.minecraft.potted_birch_sapling": "Vas con but de biolla",
  "block.minecraft.potted_blue_orchid": "Vas cont orchidea bloeu",
  "block.minecraft.potted_brown_mushroom": "Vas con fonsg marron",
  "block.minecraft.potted_cactus": "Vas con cactus",
  "block.minecraft.potted_cherry_sapling": "Vas con but de scireser",
  "block.minecraft.potted_closed_eyeblossom": "Vaso con occhidea chiusa",
  "block.minecraft.potted_cornflower": "Vas con lori",
  "block.minecraft.potted_crimson_fungus": "Vas con fonsg cremes",
  "block.minecraft.potted_crimson_roots": "Vas con radis cremese",
  "block.minecraft.potted_dandelion": "Vas con bofanella",
  "block.minecraft.potted_dark_oak_sapling": "Vas con but de rogora",
  "block.minecraft.potted_dead_bush": "Vas con pianta seca",
  "block.minecraft.potted_fern": "Vas con files",
  "block.minecraft.potted_flowering_azalea_bush": "Vas con azalea fiorida",
  "block.minecraft.potted_golden_dandelion": "Vaso con dente di leone d'oro",
  "block.minecraft.potted_jungle_sapling": "Vas con but de la sgiungla",
  "block.minecraft.potted_lily_of_the_valley": "Vas con moneghin",
  "block.minecraft.potted_mangrove_propagule": "Vas con propagul de mangrovia",
  "block.minecraft.potted_oak_sapling": "Vas con but de cerr",
  "block.minecraft.potted_open_eyeblossom": "Vaso con occhidea aperta",
  "block.minecraft.potted_orange_tulip": "Vas con tolipan naranz",
  "block.minecraft.potted_oxeye_daisy": "Vas con margherita",
  "block.minecraft.potted_pale_oak_sapling": "Vaso con arboscello di quercia pallida",
  "block.minecraft.potted_pink_tulip": "Vas con tolipan roeusa",
  "block.minecraft.potted_poppy": "Vas con popolana",
  "block.minecraft.potted_red_mushroom": "Vas con fonsg ross",
  "block.minecraft.potted_red_tulip": "Vas con tolipan ross",
  "block.minecraft.potted_spruce_sapling": "Vas con but de abiezz",
  "block.minecraft.potted_torchflower": "Vas con torcia-fior",
  "block.minecraft.potted_warped_fungus": "Vas con fonsg desformad",
  "block.minecraft.potted_warped_roots": "Vas con radis desformade",
  "block.minecraft.potted_white_tulip": "Vas con tolipan bianch",
  "block.minecraft.potted_wither_rose": "Vas con roeusa del Wither",
  "block.minecraft.powder_snow": "Fioca in polver",
  "block.minecraft.powder_snow_cauldron": "Calderon de fioca in polver",
  "block.minecraft.powered_rail": "Binari motorizad",
  "block.minecraft.prismarine": "Prismarina",
  "block.minecraft.prismarine_brick_slab": "Pioda de quadrei de prismarina",
  "block.minecraft.prismarine_brick_stairs": "Basei de quadrei de prismarina",
  "block.minecraft.prismarine_bricks": "Quadrei de prismarina",
  "block.minecraft.prismarine_slab": "Pioda de prismarina",
  "block.minecraft.prismarine_stairs": "Basei de prismarina",
  "block.minecraft.prismarine_wall": "Mur de prismarina",
  "block.minecraft.pumpkin": "Zuca",
  "block.minecraft.pumpkin_stem": "Pianta de zuca",
  "block.minecraft.purple_banner": "Bandera vioeula",
  "block.minecraft.purple_bed": "Lecc vioeula",
  "block.minecraft.purple_candle": "Candira vioeula",
  "block.minecraft.purple_candle_cake": "Torta con candila vioeula",
  "block.minecraft.purple_carpet": "Tapet vioeula",
  "block.minecraft.purple_concrete": "Ciment vioeula",
  "block.minecraft.purple_concrete_powder": "Polver de ciment vioeula",
  "block.minecraft.purple_glazed_terracotta": "Terracota smaltada vioeula",
  "block.minecraft.purple_shulker_box": "Scatola de shulker vioeula",
  "block.minecraft.purple_stained_glass": "Veder vioeula",
  "block.minecraft.purple_stained_glass_pane": "Panell de veder vioeula",
  "block.minecraft.purple_terracotta": "Terracota vioeula",
  "block.minecraft.purple_wool": "Lana vioeula",
  "block.minecraft.purpur_block": "Bloch de purpur",
  "block.minecraft.purpur_pillar": "Pilaster de purpur",
  "block.minecraft.purpur_slab": "Pioda de purpur",
  "block.minecraft.purpur_stairs": "Basei de purpur",
  "block.minecraft.quartz_block": "Bloch de quarz",
  "block.minecraft.quartz_bricks": "Quadrei de quarz",
  "block.minecraft.quartz_pillar": "Pilaster de quarz",
  "block.minecraft.quartz_slab": "Pioda de quarz",
  "block.minecraft.quartz_stairs": "Basei de quarz",
  "block.minecraft.rail": "Binari",
  "block.minecraft.raw_copper_block": "Bloch de mineral de ram",
  "block.minecraft.raw_gold_block": "Bloch de mineral d'or",
  "block.minecraft.raw_iron_block": "Bloch de mineral de ferr",
  "block.minecraft.red_banner": "Bandera rossa",
  "block.minecraft.red_bed": "Lecc ross",
  "block.minecraft.red_candle": "Candira rossa",
  "block.minecraft.red_candle_cake": "Torta con candila rossa",
  "block.minecraft.red_carpet": "Tapet ross",
  "block.minecraft.red_concrete": "Ciment ross",
  "block.minecraft.red_concrete_powder": "Polver de ciment rossa",
  "block.minecraft.red_glazed_terracotta": "Terracota smaltada rossa",
  "block.minecraft.red_mushroom": "Fonsg ross",
  "block.minecraft.red_mushroom_block": "Bloch de fonsg ross",
  "block.minecraft.red_nether_brick_slab": "Pioda de quadrei ross del Nether",
  "block.minecraft.red_nether_brick_stairs": "Basei de quadrei ross del Nether",
  "block.minecraft.red_nether_brick_wall": "Mur de quadrei ross del Nether",
  "block.minecraft.red_nether_bricks": "Quadrei ross del Nether",
  "block.minecraft.red_sand": "Sabia rossa",
  "block.minecraft.red_sandstone": "Molera rossa",
  "block.minecraft.red_sandstone_slab": "Pioda de molera rossa",
  "block.minecraft.red_sandstone_stairs": "Basei de molera rossa",
  "block.minecraft.red_sandstone_wall": "Mur de molera rossa",
  "block.minecraft.red_shulker_box": "Scatola de shulker rossa",
  "block.minecraft.red_stained_glass": "Veder ross",
  "block.minecraft.red_stained_glass_pane": "Panell de veder ross",
  "block.minecraft.red_terracotta": "Terracota rossa",
  "block.minecraft.red_tulip": "Tolipan ross",
  "block.minecraft.red_wool": "Lana rossa",
  "block.minecraft.redstone_block": "Bloch de preja rossa",
  "block.minecraft.redstone_lamp": "Lampeda de prejarossa",
  "block.minecraft.redstone_ore": "Mineral de prejarossa",
  "block.minecraft.redstone_torch": "Torcia de prejarossa",
  "block.minecraft.redstone_wall_torch": "Torcia de prejarossa de mur",
  "block.minecraft.redstone_wire": "Fil de prejarossa",
  "block.minecraft.reinforced_deepslate": "Lavagna profonda renforzada",
  "block.minecraft.repeater": "Repetidor de prejarossa",
  "block.minecraft.repeating_command_block": "Bloch di comand a repetizzion",
  "block.minecraft.resin_block": "Blocco di resina",
  "block.minecraft.resin_brick_slab": "Lastra di mattoni di resina",
  "block.minecraft.resin_brick_stairs": "Scalini di mattoni di resina",
  "block.minecraft.resin_brick_wall": "Muretto di mattoni di resina",
  "block.minecraft.resin_bricks": "Mattoni di resina",
  "block.minecraft.resin_clump": "Grumo di resina",
  "block.minecraft.respawn_anchor": "Ancora de la renassida",
  "block.minecraft.rooted_dirt": "Terra con radis",
  "block.minecraft.rose_bush": "Boscal de roeuse",
  "block.minecraft.sand": "Sabia",
  "block.minecraft.sandstone": "Molera",
  "block.minecraft.sandstone_slab": "Pioda de molera",
  "block.minecraft.sandstone_stairs": "Basei de molera",
  "block.minecraft.sandstone_wall": "Mur de molera",
  "block.minecraft.scaffolding": "Pontegg",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalizador de sculk",
  "block.minecraft.sculk_sensor": "Sensor sculk",
  "block.minecraft.sculk_shrieker": "Sculk vosador",
  "block.minecraft.sculk_vein": "Vena de sculk",
  "block.minecraft.sea_lantern": "Lanterna del mar",
  "block.minecraft.sea_pickle": "Cocumer del mar",
  "block.minecraft.seagrass": "Erba del mar",
  "block.minecraft.set_spawn": "Pont de renassida configurad",
  "block.minecraft.short_dry_grass": "Erba secca bassa",
  "block.minecraft.short_grass": "Erba bassa",
  "block.minecraft.shroomlight": "Sberlus-fonsg",
  "block.minecraft.shulker_box": "Scatola de shulker",
  "block.minecraft.skeleton_skull": "Coo de schelter",
  "block.minecraft.skeleton_wall_skull": "Coo de schelter de mur",
  "block.minecraft.slime_block": "Bloch de slime",
  "block.minecraft.small_amethyst_bud": "Gemma de ametista piscinina",
  "block.minecraft.small_dripleaf": "Foeuja-gota picola",
  "block.minecraft.smithing_table": "Tavol del ferrer",
  "block.minecraft.smoker": "Afumegador",
  "block.minecraft.smooth_basalt": "Basalt soli",
  "block.minecraft.smooth_quartz": "Bloch de quarz liss",
  "block.minecraft.smooth_quartz_slab": "Pioda de quarz liss",
  "block.minecraft.smooth_quartz_stairs": "Basei de quarz liss",
  "block.minecraft.smooth_red_sandstone": "Molera rossa lissa",
  "block.minecraft.smooth_red_sandstone_slab": "Pioda de molera rossa lissa",
  "block.minecraft.smooth_red_sandstone_stairs": "Basei de molera rossa soliada",
  "block.minecraft.smooth_sandstone": "Molera lissa",
  "block.minecraft.smooth_sandstone_slab": "Pioda de molera lissa",
  "block.minecraft.smooth_sandstone_stairs": "Basei de molera lissa",
  "block.minecraft.smooth_stone": "Preja soliada",
  "block.minecraft.smooth_stone_slab": "Pioda de preja lissa",
  "block.minecraft.sniffer_egg": "Oeuv de nasador",
  "block.minecraft.snow": "Fioca",
  "block.minecraft.snow_block": "Bloch de fioca",
  "block.minecraft.soul_campfire": "Falò de l'anima",
  "block.minecraft.soul_fire": "Foeugh di anime",
  "block.minecraft.soul_lantern": "Lanterna di anime",
  "block.minecraft.soul_sand": "Sabia di anime",
  "block.minecraft.soul_soil": "Terra di anime",
  "block.minecraft.soul_torch": "Torcia di anime",
  "block.minecraft.soul_wall_torch": "Torcia di anime de mur",
  "block.minecraft.spawn.not_valid": "Te gh'heet nissun lecc o ancora de la renassida cargada, o inn intrlciad",
  "block.minecraft.spawner": "Generatore di mostri",
  "block.minecraft.spawner.desc1": "Interazione con uovo generatore:",
  "block.minecraft.spawner.desc2": "Imposta il tipo di creatura",
  "block.minecraft.sponge": "Sponga",
  "block.minecraft.spore_blossom": "Fior produtor de spore",
  "block.minecraft.spruce_button": "Boton de abiezz",
  "block.minecraft.spruce_door": "Porta de abiezz",
  "block.minecraft.spruce_fence": "Stongarda de abiezz",
  "block.minecraft.spruce_fence_gate": "Restell de abiezz",
  "block.minecraft.spruce_hanging_sign": "Insegna de abiezz",
  "block.minecraft.spruce_leaves": "Foeuje de abiezz",
  "block.minecraft.spruce_log": "Bora de abiezz",
  "block.minecraft.spruce_planks": "Ass de abiezz",
  "block.minecraft.spruce_pressure_plate": "Pian a pression de abiezz",
  "block.minecraft.spruce_sapling": "But de abiezz",
  "block.minecraft.spruce_shelf": "Scaffale di abete",
  "block.minecraft.spruce_sign": "Cartell de abiezz",
  "block.minecraft.spruce_slab": "Pioda de abiezz",
  "block.minecraft.spruce_stairs": "Basei de abiezz",
  "block.minecraft.spruce_trapdoor": "Bussera de abiezz",
  "block.minecraft.spruce_wall_hanging_sign": "Insegna a mur de abiezz",
  "block.minecraft.spruce_wall_sign": "Cartell de mur de abiezz",
  "block.minecraft.spruce_wood": "Legn de abiezz",
  "block.minecraft.sticky_piston": "Piston impatachent",
  "block.minecraft.stone": "Preja",
  "block.minecraft.stone_brick_slab": "Pioda de quadrei de preja",
  "block.minecraft.stone_brick_stairs": "Basei de quadrei de preja",
  "block.minecraft.stone_brick_wall": "Mur de quadrei de preja",
  "block.minecraft.stone_bricks": "Quadrei de preja",
  "block.minecraft.stone_button": "Boton de preja",
  "block.minecraft.stone_pressure_plate": "Pian a pression de preja",
  "block.minecraft.stone_slab": "Pioda de preja",
  "block.minecraft.stone_stairs": "Basei de preja",
  "block.minecraft.stonecutter": "Taja-preje",
  "block.minecraft.stripped_acacia_log": "Bora de rubinia scarpada",
  "block.minecraft.stripped_acacia_wood": "Legn de rubinia scarpad",
  "block.minecraft.stripped_bamboo_block": "Bloch de bamboo scarpad",
  "block.minecraft.stripped_birch_log": "Bora de biolla scarpada",
  "block.minecraft.stripped_birch_wood": "Legn de biolla scarpad",
  "block.minecraft.stripped_cherry_log": "Bora de cireser scarpad",
  "block.minecraft.stripped_cherry_wood": "Legn de scireser scarpad",
  "block.minecraft.stripped_crimson_hyphae": "Ife cremese scarpade",
  "block.minecraft.stripped_crimson_stem": "Gamba cremesa scarpada",
  "block.minecraft.stripped_dark_oak_log": "Bora de rogora scarpada",
  "block.minecraft.stripped_dark_oak_wood": "Legn de rogora scarpad",
  "block.minecraft.stripped_jungle_log": "Bora de la giungla scarpada",
  "block.minecraft.stripped_jungle_wood": "Legn de la giungla scarpad",
  "block.minecraft.stripped_mangrove_log": "Bora de mangrovia scarpada",
  "block.minecraft.stripped_mangrove_wood": "Legn de mangrovia scarpad",
  "block.minecraft.stripped_oak_log": "Bora de cerr scarpada",
  "block.minecraft.stripped_oak_wood": "Legn de cerr scarpad",
  "block.minecraft.stripped_pale_oak_log": "Bora de cerr slavi scarpada",
  "block.minecraft.stripped_pale_oak_wood": "Legno di quercia pallida scortecciato",
  "block.minecraft.stripped_spruce_log": "Bora de abiezz scarpada",
  "block.minecraft.stripped_spruce_wood": "Legn de abiezz scarpad",
  "block.minecraft.stripped_warped_hyphae": "Ife desformade scarpade",
  "block.minecraft.stripped_warped_stem": "Gamba desformada scarpada",
  "block.minecraft.structure_block": "Bloch strutura",
  "block.minecraft.structure_void": "Voeui de la strutura",
  "block.minecraft.sugar_cane": "Cana de zucher",
  "block.minecraft.sunflower": "Girasol",
  "block.minecraft.suspicious_gravel": "Gera sospeta",
  "block.minecraft.suspicious_sand": "Sabia sospeta",
  "block.minecraft.sweet_berry_bush": "Boscal de frut dolz",
  "block.minecraft.tall_dry_grass": "Erba secca alta",
  "block.minecraft.tall_grass": "Erba volta",
  "block.minecraft.tall_seagrass": "Erba volta del mar",
  "block.minecraft.target": "Bersai",
  "block.minecraft.terracotta": "Terracota",
  "block.minecraft.test_block": "Blocco di test",
  "block.minecraft.test_instance_block": "Blocco di collaudo",
  "block.minecraft.tinted_glass": "Veder colorad",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Le esplosioni di TNT sono disattivate",
  "block.minecraft.torch": "Torcia",
  "block.minecraft.torchflower": "Torcia-fior",
  "block.minecraft.torchflower_crop": "Pianta de torcia-fior",
  "block.minecraft.trapped_chest": "Cesta-trapola",
  "block.minecraft.trial_spawner": "Generatore della sfida",
  "block.minecraft.tripwire": "Fil trapola",
  "block.minecraft.tripwire_hook": "Rampin de fil trapola",
  "block.minecraft.tube_coral": "Corall a tubo",
  "block.minecraft.tube_coral_block": "Bloch de corall a tubo",
  "block.minecraft.tube_coral_fan": "Gorgonia a tubo",
  "block.minecraft.tube_coral_wall_fan": "Gorgonia a tubo a mur",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Lastra di mattoni di tufo",
  "block.minecraft.tuff_brick_stairs": "Scalini di mattoni di tufo",
  "block.minecraft.tuff_brick_wall": "Muretto di mattoni di tufo",
  "block.minecraft.tuff_bricks": "Mattoni di tufo",
  "block.minecraft.tuff_slab": "Lastra di tufo",
  "block.minecraft.tuff_stairs": "Scalini di tufo",
  "block.minecraft.tuff_wall": "Muretto di tufo",
  "block.minecraft.turtle_egg": "Oeuv de bissa scudellera",
  "block.minecraft.twisting_vines": "Ergna intortia",
  "block.minecraft.twisting_vines_plant": "Pianta de ergna intortia",
  "block.minecraft.vault": "Cassaforte",
  "block.minecraft.verdant_froglight": "Rana-lus verdenta",
  "block.minecraft.vine": "Ergna",
  "block.minecraft.void_air": "Aria del voeui",
  "block.minecraft.wall_torch": "Torcia de mur",
  "block.minecraft.warped_button": "Boton desformad",
  "block.minecraft.warped_door": "Porta desformada",
  "block.minecraft.warped_fence": "Stongarda desformada",
  "block.minecraft.warped_fence_gate": "Restell desformad",
  "block.minecraft.warped_fungus": "Fonsg desformad",
  "block.minecraft.warped_hanging_sign": "Insegna desformada",
  "block.minecraft.warped_hyphae": "Ife desformade",
  "block.minecraft.warped_nylium": "Neceli desformad",
  "block.minecraft.warped_planks": "Ass desformade",
  "block.minecraft.warped_pressure_plate": "Pian a pression desformad",
  "block.minecraft.warped_roots": "Radis desformade",
  "block.minecraft.warped_shelf": "Scaffale distorto",
  "block.minecraft.warped_sign": "Cartell desformad",
  "block.minecraft.warped_slab": "Pioda desformada",
  "block.minecraft.warped_stairs": "Basei desformad",
  "block.minecraft.warped_stem": "Gamba desformada",
  "block.minecraft.warped_trapdoor": "Bussera desformada",
  "block.minecraft.warped_wall_hanging_sign": "Insegna a mur desformada",
  "block.minecraft.warped_wall_sign": "Cartell de mur desformad",
  "block.minecraft.warped_wart_block": "Bloch de brossera desformada",
  "block.minecraft.water": "Aqua",
  "block.minecraft.water_cauldron": "Calderon de aqua",
  "block.minecraft.waxed_chiseled_copper": "Rame cesellato cerato",
  "block.minecraft.waxed_copper_bars": "Sbarre di rame cerato",
  "block.minecraft.waxed_copper_block": "Bloch de ram incerad",
  "block.minecraft.waxed_copper_bulb": "Lampada di rame cerato",
  "block.minecraft.waxed_copper_chain": "Catena di rame cerato",
  "block.minecraft.waxed_copper_chest": "Baule di rame cerato",
  "block.minecraft.waxed_copper_door": "Porta di rame cerato",
  "block.minecraft.waxed_copper_golem_statue": "Statua di golem di rame cerato",
  "block.minecraft.waxed_copper_grate": "Grata di rame cerato",
  "block.minecraft.waxed_copper_lantern": "Lanterna di rame cerato",
  "block.minecraft.waxed_copper_trapdoor": "Botola di rame cerato",
  "block.minecraft.waxed_cut_copper": "Ram tajad incerad",
  "block.minecraft.waxed_cut_copper_slab": "Pioda de ram tajad incerad",
  "block.minecraft.waxed_cut_copper_stairs": "Basei de ram tajad incerad",
  "block.minecraft.waxed_exposed_chiseled_copper": "Rame cesellato esposto cerato",
  "block.minecraft.waxed_exposed_copper": "Ram espost incerad",
  "block.minecraft.waxed_exposed_copper_bars": "Sbarre di rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_bulb": "Lampada di rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_chain": "Catena di rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_chest": "Baule di rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_door": "Porta di rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Statua di golem di rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_grate": "Grata di rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_lantern": "Lanterna di rame esposto cerato",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Botola di rame esposto cerato",
  "block.minecraft.waxed_exposed_cut_copper": "Ram tajad espost incerad",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Pioda de ram tajad espost incerad",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Basei de ram tajad espost incerad",
  "block.minecraft.waxed_exposed_lightning_rod": "Parafulmine esposto cerato",
  "block.minecraft.waxed_lightning_rod": "Parafulmine cerato",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Rame cesellato ossidato cerato",
  "block.minecraft.waxed_oxidized_copper": "Ram ossidad incerad",
  "block.minecraft.waxed_oxidized_copper_bars": "Sbarre di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_bulb": "Lampada di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_chain": "Catena di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_chest": "Baule di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_door": "Porta di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Statua di golem di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_grate": "Grata di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_lantern": "Lanterna di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Botola di rame ossidato cerato",
  "block.minecraft.waxed_oxidized_cut_copper": "Ram tajad ossidad incerad",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Pioda de ram tajad ossidad incerad",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Basei de ram tajad ossidad incerad",
  "block.minecraft.waxed_oxidized_lightning_rod": "Parafulmine ossidato cerato",
  "block.minecraft.waxed_weathered_chiseled_copper": "Rame cesellato corroso cerato",
  "block.minecraft.waxed_weathered_copper": "Ram smangiad incerad",
  "block.minecraft.waxed_weathered_copper_bars": "Sbarre di rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_bulb": "Lampada di rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_chain": "Catena di rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_chest": "Baule di rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_door": "Porta di rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Statua di golem di rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_grate": "Grata di rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_lantern": "Lanterna di rame corroso cerato",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Botola di rame corroso cerato",
  "block.minecraft.waxed_weathered_cut_copper": "Ram tajad smangiad incerad",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Pioda de ram tajad smangiad incerad",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Basei de ram tajad smangiad incerad",
  "block.minecraft.waxed_weathered_lightning_rod": "Parafulmine corroso cerato",
  "block.minecraft.weathered_chiseled_copper": "Rame cesellato corroso",
  "block.minecraft.weathered_copper": "Ram ruvinad",
  "block.minecraft.weathered_copper_bars": "Sbarre di rame corroso",
  "block.minecraft.weathered_copper_bulb": "Lampada di rame corroso",
  "block.minecraft.weathered_copper_chain": "Catena di rame corroso",
  "block.minecraft.weathered_copper_chest": "Baule di rame corroso",
  "block.minecraft.weathered_copper_door": "Porta di rame corroso",
  "block.minecraft.weathered_copper_golem_statue": "Statua di golem di rame corroso",
  "block.minecraft.weathered_copper_grate": "Grata di rame corroso",
  "block.minecraft.weathered_copper_lantern": "Lanterna di rame corroso",
  "block.minecraft.weathered_copper_trapdoor": "Botola di rame corroso",
  "block.minecraft.weathered_cut_copper": "Ram tajad smangiad",
  "block.minecraft.weathered_cut_copper_slab": "Pioda de ram tajad smangiad",
  "block.minecraft.weathered_cut_copper_stairs": "Basei de ram tajad smangiad",
  "block.minecraft.weathered_lightning_rod": "Parafulmine corroso",
  "block.minecraft.weeping_vines": "Ergna caragnenta",
  "block.minecraft.weeping_vines_plant": "Pianta de ergna caragnenta",
  "block.minecraft.wet_sponge": "Sponga masarada",
  "block.minecraft.wheat": "Forment",
  "block.minecraft.white_banner": "Bandera bianca",
  "block.minecraft.white_bed": "Lecc bianch",
  "block.minecraft.white_candle": "Candira bianca",
  "block.minecraft.white_candle_cake": "Torta con candila bianca",
  "block.minecraft.white_carpet": "Tapet bianch",
  "block.minecraft.white_concrete": "Ciment bianch",
  "block.minecraft.white_concrete_powder": "Polver de ciment bianca",
  "block.minecraft.white_glazed_terracotta": "Terracota smaltada bianca",
  "block.minecraft.white_shulker_box": "Scatola de shulker bianca",
  "block.minecraft.white_stained_glass": "Veder bianch",
  "block.minecraft.white_stained_glass_pane": "Panell de veder bianch",
  "block.minecraft.white_terracotta": "Terracota bianca",
  "block.minecraft.white_tulip": "Tolipan bianch",
  "block.minecraft.white_wool": "Lana bianca",
  "block.minecraft.wildflowers": "Fiori di campo",
  "block.minecraft.wither_rose": "Roeusa del Wither",
  "block.minecraft.wither_skeleton_skull": "Coo de schelter wither",
  "block.minecraft.wither_skeleton_wall_skull": "Coo de schelter wither a mur",
  "block.minecraft.yellow_banner": "Bandera sgialda",
  "block.minecraft.yellow_bed": "Lecc sgiald",
  "block.minecraft.yellow_candle": "Candira sgialda",
  "block.minecraft.yellow_candle_cake": "Torta con candila sgialda",
  "block.minecraft.yellow_carpet": "Tapet sgiald",
  "block.minecraft.yellow_concrete": "Ciment sgiald",
  "block.minecraft.yellow_concrete_powder": "Polver de ciment sgialda",
  "block.minecraft.yellow_glazed_terracotta": "Terracota smaltada sgialda",
  "block.minecraft.yellow_shulker_box": "Scatola de shulker sgialda",
  "block.minecraft.yellow_stained_glass": "Veder sgiald",
  "block.minecraft.yellow_stained_glass_pane": "Panell de veder sgiald",
  "block.minecraft.yellow_terracotta": "Terracota sgialda",
  "block.minecraft.yellow_wool": "Lana sgialda",
  "block.minecraft.zombie_head": "Coo de zombie",
  "block.minecraft.zombie_wall_head": "Coo de zombie de mur",
  "item.minecraft.acacia_boat": "Barca de rubinia",
  "item.minecraft.acacia_chest_boat": "Barca de rubinia con cesta",
  "item.minecraft.allay_spawn_egg": "Oeuv de allay",
  "item.minecraft.amethyst_shard": "Scheja de ametista",
  "item.minecraft.angler_pottery_shard": "Toch de terra-cota con cana de pesca",
  "item.minecraft.angler_pottery_sherd": "Toch de terra-cota con cana de pesca",
  "item.minecraft.apple": "Pom",
  "item.minecraft.archer_pottery_shard": "Toch de terra-cota con arch",
  "item.minecraft.archer_pottery_sherd": "Toch de terra-cota con arch",
  "item.minecraft.armadillo_scute": "Squama di armadillo",
  "item.minecraft.armadillo_spawn_egg": "Uovo generatore di armadillo",
  "item.minecraft.armor_stand": "Suport per armadure",
  "item.minecraft.arms_up_pottery_shard": "Toch de terra-cota con figura",
  "item.minecraft.arms_up_pottery_sherd": "Toch de terra-cota con figura",
  "item.minecraft.arrow": "Flizza",
  "item.minecraft.axolotl_bucket": "Sidel con assolot",
  "item.minecraft.axolotl_spawn_egg": "Oeuv de axolotl",
  "item.minecraft.baked_potato": "Pom de terra cot",
  "item.minecraft.bamboo_chest_raft": "Barchin de bamboo con cesta",
  "item.minecraft.bamboo_raft": "Barchin de bamboo",
  "item.minecraft.bat_spawn_egg": "Oeuv de tegnoeula",
  "item.minecraft.bee_spawn_egg": "Oeuv de ava",
  "item.minecraft.beef": "Manz crud",
  "item.minecraft.beetroot": "Biedrava",
  "item.minecraft.beetroot_seeds": "Somenza de biedrave",
  "item.minecraft.beetroot_soup": "Supa de biedrave",
  "item.minecraft.birch_boat": "Barca de biolla",
  "item.minecraft.birch_chest_boat": "Barca de biolla con cesta",
  "item.minecraft.black_bundle": "Sacchetto nero",
  "item.minecraft.black_dye": "Colorant negher",
  "item.minecraft.black_harness": "Imbracatura nera",
  "item.minecraft.blade_pottery_shard": "Toch de terra-cota con spada",
  "item.minecraft.blade_pottery_sherd": "Toch de terra-cota con spada",
  "item.minecraft.blaze_powder": "Polver de blaze",
  "item.minecraft.blaze_rod": "Verga del blaze",
  "item.minecraft.blaze_spawn_egg": "Oeuv de blaze",
  "item.minecraft.blue_bundle": "Sacchetto blu",
  "item.minecraft.blue_dye": "Colorant bloeu",
  "item.minecraft.blue_egg": "Uovo blu",
  "item.minecraft.blue_harness": "Imbracatura blu",
  "item.minecraft.bogged_spawn_egg": "Uovo generatore di paludoso",
  "item.minecraft.bolt_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Ornamento stile bullone",
  "item.minecraft.bone": "Oss",
  "item.minecraft.bone_meal": "Polver de oss",
  "item.minecraft.book": "Liber",
  "item.minecraft.bordure_indented_banner_pattern": "Motivo con bordatura dentata",
  "item.minecraft.bow": "Arch",
  "item.minecraft.bowl": "Squella",
  "item.minecraft.bread": "Pan",
  "item.minecraft.breeze_rod": "Verga di brezza",
  "item.minecraft.breeze_spawn_egg": "Uovo generatore di brezza",
  "item.minecraft.brewer_pottery_shard": "Toch de terra-cota con pozzion",
  "item.minecraft.brewer_pottery_sherd": "Toch de terra-cota con pozzion",
  "item.minecraft.brewing_stand": "Lambich",
  "item.minecraft.brick": "Quadrell",
  "item.minecraft.brown_bundle": "Sacchetto marrone",
  "item.minecraft.brown_dye": "Colorant marron",
  "item.minecraft.brown_egg": "Uovo marrone",
  "item.minecraft.brown_harness": "Imbracatura marrone",
  "item.minecraft.brush": "Penell",
  "item.minecraft.bucket": "Sidell",
  "item.minecraft.bundle": "Sachet",
  "item.minecraft.bundle.empty": "Vuoto",
  "item.minecraft.bundle.empty.description": "Può contenere una pila mista di oggetti",
  "item.minecraft.bundle.full": "Pieno",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Toch de terra-cota con foeugh",
  "item.minecraft.burn_pottery_sherd": "Toch de terra-cota con foeugh",
  "item.minecraft.camel_husk_spawn_egg": "Uovo generatore di mummifario",
  "item.minecraft.camel_spawn_egg": "Oeuv de camell",
  "item.minecraft.carrot": "Carotola",
  "item.minecraft.carrot_on_a_stick": "Baston e carotola",
  "item.minecraft.cat_spawn_egg": "Oeuv de gat",
  "item.minecraft.cauldron": "Calderon",
  "item.minecraft.cave_spider_spawn_egg": "Oeuv de ragn di grote",
  "item.minecraft.chainmail_boots": "Strivai de maja",
  "item.minecraft.chainmail_chestplate": "Cota de maja",
  "item.minecraft.chainmail_helmet": "Elm de maja",
  "item.minecraft.chainmail_leggings": "Gambai de maja",
  "item.minecraft.charcoal": "Carbonella",
  "item.minecraft.cherry_boat": "Barca de scireser",
  "item.minecraft.cherry_chest_boat": "Barca de scireser con cesta",
  "item.minecraft.chest_minecart": "Carrell de minera con cesta",
  "item.minecraft.chicken": "Pollaster crud",
  "item.minecraft.chicken_spawn_egg": "Oeuv de pollaster",
  "item.minecraft.chorus_fruit": "Frut de chorus",
  "item.minecraft.clay_ball": "Balla de argilla",
  "item.minecraft.clock": "Orelogg",
  "item.minecraft.coal": "Carbon",
  "item.minecraft.coast_armor_trim_smithing_template": "Model del ferrer",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Ornamento stile costiero",
  "item.minecraft.cocoa_beans": "Fave de cacao",
  "item.minecraft.cod": "Merluzz crud",
  "item.minecraft.cod_bucket": "Sidell con merluzz",
  "item.minecraft.cod_spawn_egg": "Oeuv de merluzz",
  "item.minecraft.command_block_minecart": "Carrell de minera con bloch di comand",
  "item.minecraft.compass": "Bussola",
  "item.minecraft.cooked_beef": "Bisteca",
  "item.minecraft.cooked_chicken": "Pollaster cot",
  "item.minecraft.cooked_cod": "Merluzz cot",
  "item.minecraft.cooked_mutton": "Bar cot",
  "item.minecraft.cooked_porkchop": "Brassoeula de porcell cota",
  "item.minecraft.cooked_rabbit": "Conili cot",
  "item.minecraft.cooked_salmon": "Salmon cot",
  "item.minecraft.cookie": "Biscot",
  "item.minecraft.copper_axe": "Ascia di rame",
  "item.minecraft.copper_boots": "Stivali di rame",
  "item.minecraft.copper_chestplate": "Corazza di rame",
  "item.minecraft.copper_golem_spawn_egg": "Uovo generatore di golem di rame",
  "item.minecraft.copper_helmet": "Elmo di rame",
  "item.minecraft.copper_hoe": "Zappa di rame",
  "item.minecraft.copper_horse_armor": "Bardatura di rame",
  "item.minecraft.copper_ingot": "Lingot de ram",
  "item.minecraft.copper_leggings": "Gambiere di rame",
  "item.minecraft.copper_nautilus_armor": "Armatura di rame per nautili",
  "item.minecraft.copper_nugget": "Pepita di rame",
  "item.minecraft.copper_pickaxe": "Piccone di rame",
  "item.minecraft.copper_shovel": "Pala di rame",
  "item.minecraft.copper_spear": "Lancia di rame",
  "item.minecraft.copper_sword": "Spada di rame",
  "item.minecraft.cow_spawn_egg": "Oeuv de vaca",
  "item.minecraft.creaking_spawn_egg": "Uovo generatore di scricchio",
  "item.minecraft.creeper_banner_pattern": "Motiv de la bandera",
  "item.minecraft.creeper_banner_pattern.desc": "Faza de creeper",
  "item.minecraft.creeper_banner_pattern.new": "Motivo con volto di creeper",
  "item.minecraft.creeper_spawn_egg": "Oeuv de creeper",
  "item.minecraft.crossbow": "Balestra",
  "item.minecraft.crossbow.projectile": "Balla:",
  "item.minecraft.crossbow.projectile.multiple": "Proiettile: %s × %s",
  "item.minecraft.crossbow.projectile.single": "Proiettile: %s",
  "item.minecraft.cyan_bundle": "Sacchetto ciano",
  "item.minecraft.cyan_dye": "Colorant celest",
  "item.minecraft.cyan_harness": "Imbracatura ciano",
  "item.minecraft.danger_pottery_shard": "Toch de terra-cota con creeper",
  "item.minecraft.danger_pottery_sherd": "Toch de terra-cota con creeper",
  "item.minecraft.dark_oak_boat": "Barca de rogora",
  "item.minecraft.dark_oak_chest_boat": "Barca de rogora con cesta",
  "item.minecraft.debug_stick": "Baston de debug",
  "item.minecraft.debug_stick.empty": "%s el gh'ha mìa proprietà",
  "item.minecraft.debug_stick.select": "scernid \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" adess l'è %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Segurin de diamant",
  "item.minecraft.diamond_boots": "Strivai de diamant",
  "item.minecraft.diamond_chestplate": "Corazza de diamant",
  "item.minecraft.diamond_helmet": "Elm de diamant",
  "item.minecraft.diamond_hoe": "Zapa de diamant",
  "item.minecraft.diamond_horse_armor": "Armadura de diamant per cavall",
  "item.minecraft.diamond_leggings": "Gambai de diamant",
  "item.minecraft.diamond_nautilus_armor": "Armatura di diamante per nautili",
  "item.minecraft.diamond_pickaxe": "Picozz de diamant",
  "item.minecraft.diamond_shovel": "Baira de diamant",
  "item.minecraft.diamond_spear": "Lancia di diamante",
  "item.minecraft.diamond_sword": "Spada de diamant",
  "item.minecraft.disc_fragment_5": "Toch de disch",
  "item.minecraft.disc_fragment_5.desc": "Disch de musega - 5",
  "item.minecraft.dolphin_spawn_egg": "Oeuv de delfin",
  "item.minecraft.donkey_spawn_egg": "Oeuv de asen",
  "item.minecraft.dragon_breath": "Bofada de dragon",
  "item.minecraft.dried_kelp": "Alga seca",
  "item.minecraft.drowned_spawn_egg": "Oeuv de negad",
  "item.minecraft.dune_armor_trim_smithing_template": "Model del ferrer",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ornamento stile duna",
  "item.minecraft.echo_shard": "Scheja resonanta",
  "item.minecraft.egg": "Oeuv",
  "item.minecraft.elder_guardian_spawn_egg": "Oeuv de guardian antigh",
  "item.minecraft.elytra": "Eliter",
  "item.minecraft.emerald": "Smerald",
  "item.minecraft.enchanted_book": "Liber instriad",
  "item.minecraft.enchanted_golden_apple": "Pom d'or instriad",
  "item.minecraft.end_crystal": "Cristall de l'End",
  "item.minecraft.ender_dragon_spawn_egg": "Oeuv de l'Enderdragon",
  "item.minecraft.ender_eye": "Oeugg de l'ender",
  "item.minecraft.ender_pearl": "Perla de l'ender",
  "item.minecraft.enderman_spawn_egg": "Oeuv de enderman",
  "item.minecraft.endermite_spawn_egg": "Oeuv de endermite",
  "item.minecraft.evoker_spawn_egg": "Oeuv de evocador",
  "item.minecraft.experience_bottle": "Botilia d'esperienza",
  "item.minecraft.explorer_pottery_shard": "Toch de terra-cota con mapa",
  "item.minecraft.explorer_pottery_sherd": "Toch de terra-cota con mapa",
  "item.minecraft.eye_armor_trim_smithing_template": "Model del ferrer",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Ornamento stile occhio",
  "item.minecraft.feather": "Piuma",
  "item.minecraft.fermented_spider_eye": "Oeugg de ragn surbuid",
  "item.minecraft.field_masoned_banner_pattern": "Motivo con seminato di mattoni",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Carga de foeugh",
  "item.minecraft.firework_rocket": "Razz pirotecnegh",
  "item.minecraft.firework_rocket.flight": "Durada del sgol:",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Stella pirotecnega",
  "item.minecraft.firework_star.black": "Negher",
  "item.minecraft.firework_star.blue": "Bloeu",
  "item.minecraft.firework_star.brown": "Marron",
  "item.minecraft.firework_star.custom_color": "Personalizad",
  "item.minecraft.firework_star.cyan": "Celest",
  "item.minecraft.firework_star.fade_to": "Sfuma in",
  "item.minecraft.firework_star.flicker": "Lusor",
  "item.minecraft.firework_star.gray": "Gris",
  "item.minecraft.firework_star.green": "Verd",
  "item.minecraft.firework_star.light_blue": "Bloeu ciar",
  "item.minecraft.firework_star.light_gray": "Gris ciar",
  "item.minecraft.firework_star.lime": "Lime",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Naranz",
  "item.minecraft.firework_star.pink": "Roeusa",
  "item.minecraft.firework_star.purple": "Vioeula",
  "item.minecraft.firework_star.red": "Ross",
  "item.minecraft.firework_star.shape": "Forma descognossuda",
  "item.minecraft.firework_star.shape.burst": "S'ciop",
  "item.minecraft.firework_star.shape.creeper": "A forma de creeper",
  "item.minecraft.firework_star.shape.large_ball": "Balla granda",
  "item.minecraft.firework_star.shape.small_ball": "Balla piscinina",
  "item.minecraft.firework_star.shape.star": "A forma de stella",
  "item.minecraft.firework_star.trail": "Segn",
  "item.minecraft.firework_star.white": "Bianch",
  "item.minecraft.firework_star.yellow": "Sgiald",
  "item.minecraft.fishing_rod": "Cana de pescà",
  "item.minecraft.flint": "Serizz",
  "item.minecraft.flint_and_steel": "Spara-foeugh",
  "item.minecraft.flow_armor_trim_smithing_template": "Schema di forgiatura",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Ornamento stile flusso",
  "item.minecraft.flow_banner_pattern": "Motivo per stendardo",
  "item.minecraft.flow_banner_pattern.desc": "Flusso",
  "item.minecraft.flow_banner_pattern.new": "Motivo con flusso",
  "item.minecraft.flow_pottery_sherd": "Coccio con flusso",
  "item.minecraft.flower_banner_pattern": "Motiv de la bandera",
  "item.minecraft.flower_banner_pattern.desc": "Fior",
  "item.minecraft.flower_banner_pattern.new": "Motivo con fiore",
  "item.minecraft.flower_pot": "Vas de fior",
  "item.minecraft.fox_spawn_egg": "Oeuv de volp",
  "item.minecraft.friend_pottery_shard": "Toch de terra-cota con amis",
  "item.minecraft.friend_pottery_sherd": "Toch de terra-cota con amis",
  "item.minecraft.frog_spawn_egg": "Oeuv de rana",
  "item.minecraft.furnace_minecart": "Carrell de minera con prestin",
  "item.minecraft.ghast_spawn_egg": "Oeuv de ghast",
  "item.minecraft.ghast_tear": "Lagrima de ghast",
  "item.minecraft.glass_bottle": "Botilia de veder",
  "item.minecraft.glistering_melon_slice": "Feta de inguria lusenta",
  "item.minecraft.globe_banner_pattern": "Motiv de la bandera",
  "item.minecraft.globe_banner_pattern.desc": "Pianeta",
  "item.minecraft.globe_banner_pattern.new": "Motivo con globo",
  "item.minecraft.glow_berries": "Borlit sberlusent",
  "item.minecraft.glow_ink_sac": "Saca de incioster sberlusenta",
  "item.minecraft.glow_item_frame": "Cornis sberlusenta",
  "item.minecraft.glow_squid_spawn_egg": "Oeuv de calamar sberlusent",
  "item.minecraft.glowstone_dust": "Polver de preja lusenta",
  "item.minecraft.goat_horn": "Corn de cavra",
  "item.minecraft.goat_spawn_egg": "Oeuv de cavra",
  "item.minecraft.gold_ingot": "Lingot d'or",
  "item.minecraft.gold_nugget": "Pepita d'ora",
  "item.minecraft.golden_apple": "Pom d'or",
  "item.minecraft.golden_axe": "Segurin d'or",
  "item.minecraft.golden_boots": "Strivai d'or",
  "item.minecraft.golden_carrot": "Carotola d'ora",
  "item.minecraft.golden_chestplate": "Corazza d'ora",
  "item.minecraft.golden_helmet": "Elm d'or",
  "item.minecraft.golden_hoe": "Zapa d'or",
  "item.minecraft.golden_horse_armor": "Armadura d'ora per cavall",
  "item.minecraft.golden_leggings": "Gambai d'or",
  "item.minecraft.golden_nautilus_armor": "Armatura d'oro per nautili",
  "item.minecraft.golden_pickaxe": "Picozz d'or",
  "item.minecraft.golden_shovel": "Baira d'ora",
  "item.minecraft.golden_spear": "Lancia d'oro",
  "item.minecraft.golden_sword": "Spada d'or",
  "item.minecraft.gray_bundle": "Sacchetto grigio",
  "item.minecraft.gray_dye": "Colorant gris",
  "item.minecraft.gray_harness": "Imbracatura grigia",
  "item.minecraft.green_bundle": "Sacchetto verde",
  "item.minecraft.green_dye": "Colorant verd",
  "item.minecraft.green_harness": "Imbracatura verde",
  "item.minecraft.guardian_spawn_egg": "Oeuv de guardian",
  "item.minecraft.gunpowder": "Polver de s'ciop",
  "item.minecraft.guster_banner_pattern": "Motivo per stendardo",
  "item.minecraft.guster_banner_pattern.desc": "Raffica",
  "item.minecraft.guster_banner_pattern.new": "Motivo con raffica",
  "item.minecraft.guster_pottery_sherd": "Coccio con raffica",
  "item.minecraft.happy_ghast_spawn_egg": "Uovo generatore di ghast allegro",
  "item.minecraft.harness": "Imbracatura",
  "item.minecraft.heart_of_the_sea": "Coeur del mar",
  "item.minecraft.heart_pottery_shard": "Toch de terra-cota con coeur",
  "item.minecraft.heart_pottery_sherd": "Toch de terra-cota con coeur",
  "item.minecraft.heartbreak_pottery_shard": "Toch de terra-cota con coeur s'cepad",
  "item.minecraft.heartbreak_pottery_sherd": "Toch de terra-cota con coeur s'cepad",
  "item.minecraft.hoglin_spawn_egg": "Oeuv de hoglin",
  "item.minecraft.honey_bottle": "Botilia de mel",
  "item.minecraft.honeycomb": "Beden",
  "item.minecraft.hopper_minecart": "Carrell de minera con tramoeugia",
  "item.minecraft.horse_spawn_egg": "Oeuv de cavall",
  "item.minecraft.host_armor_trim_smithing_template": "Model del ferrer",
  "item.minecraft.host_armor_trim_smithing_template.new": "Ornamento stile ospitante",
  "item.minecraft.howl_pottery_shard": "Toch de terra-cota con lov",
  "item.minecraft.howl_pottery_sherd": "Toch de terra-cota con lov",
  "item.minecraft.husk_spawn_egg": "Oeuv de zombie del desert",
  "item.minecraft.ink_sac": "Saca de incioster",
  "item.minecraft.iron_axe": "Segurin de ferr",
  "item.minecraft.iron_boots": "Strivai de ferr",
  "item.minecraft.iron_chestplate": "Corazza de ferr",
  "item.minecraft.iron_golem_spawn_egg": "Oeuv de golem de ferr",
  "item.minecraft.iron_helmet": "Elm de ferr",
  "item.minecraft.iron_hoe": "Zapa de ferr",
  "item.minecraft.iron_horse_armor": "Armadura de ferr per cavall",
  "item.minecraft.iron_ingot": "Lingot de ferr",
  "item.minecraft.iron_leggings": "Gambai de ferr",
  "item.minecraft.iron_nautilus_armor": "Armatura di ferro per nautili",
  "item.minecraft.iron_nugget": "Pepita de ferr",
  "item.minecraft.iron_pickaxe": "Picozz de ferr",
  "item.minecraft.iron_shovel": "Baira de ferr",
  "item.minecraft.iron_spear": "Lancia di ferro",
  "item.minecraft.iron_sword": "Spada de ferr",
  "item.minecraft.item_frame": "Cornis",
  "item.minecraft.jungle_boat": "Barca de la sgiungla",
  "item.minecraft.jungle_chest_boat": "Barca de la sgiungla con cesta",
  "item.minecraft.knowledge_book": "Liber de la cognossenza",
  "item.minecraft.lapis_lazuli": "Lapislazzer",
  "item.minecraft.lava_bucket": "Sidell de lava",
  "item.minecraft.lead": "Sguinzal",
  "item.minecraft.leather": "Coram",
  "item.minecraft.leather_boots": "Strivai de coram",
  "item.minecraft.leather_chestplate": "Gipa de coram",
  "item.minecraft.leather_helmet": "Capell de coram",
  "item.minecraft.leather_horse_armor": "Armadura de coram per cavall",
  "item.minecraft.leather_leggings": "Braghe de coram",
  "item.minecraft.light_blue_bundle": "Sacchetto azzurro",
  "item.minecraft.light_blue_dye": "Colorant bloeu ciar",
  "item.minecraft.light_blue_harness": "Imbracatura azzurra",
  "item.minecraft.light_gray_bundle": "Sacchetto grigio chiaro",
  "item.minecraft.light_gray_dye": "Colorant gris ciar",
  "item.minecraft.light_gray_harness": "Imbracatura grigio chiaro",
  "item.minecraft.lime_bundle": "Sacchetto lime",
  "item.minecraft.lime_dye": "Colorant lime",
  "item.minecraft.lime_harness": "Imbracatura lime",
  "item.minecraft.lingering_potion": "Pozzion persistenta",
  "item.minecraft.lingering_potion.effect.awkward": "Pozzion strana persistenta",
  "item.minecraft.lingering_potion.effect.empty": "Pozzion persistenta minga fabricabil",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Pozzion persistenta de resistenza al foeugh",
  "item.minecraft.lingering_potion.effect.harming": "Pozzion persistenta de dagn",
  "item.minecraft.lingering_potion.effect.healing": "Pozzion persistenta de cura",
  "item.minecraft.lingering_potion.effect.infested": "Pozione persistente d'infestazione",
  "item.minecraft.lingering_potion.effect.invisibility": "Pozzion persistenta d'invisibilità",
  "item.minecraft.lingering_potion.effect.leaping": "Pozzion persistenta de salt",
  "item.minecraft.lingering_potion.effect.levitation": "Pozzion persistenta de levitazzion",
  "item.minecraft.lingering_potion.effect.luck": "Pozzion persistenta de fortuna",
  "item.minecraft.lingering_potion.effect.mundane": "Pozzion normala persistenta",
  "item.minecraft.lingering_potion.effect.night_vision": "Pozzion persistenta de la vision per la nocc",
  "item.minecraft.lingering_potion.effect.oozing": "Pozione persistente di trasudazione",
  "item.minecraft.lingering_potion.effect.poison": "Pozzion persistenta de velen",
  "item.minecraft.lingering_potion.effect.regeneration": "Pozzion persistenta de regenerazzion",
  "item.minecraft.lingering_potion.effect.slow_falling": "Pozzion persistenta de borlada lenta",
  "item.minecraft.lingering_potion.effect.slowness": "Pozzion persistenta de lentezza",
  "item.minecraft.lingering_potion.effect.strength": "Pozzion persistenta de forza",
  "item.minecraft.lingering_potion.effect.swiftness": "Pozzion persistenta de sveltezza",
  "item.minecraft.lingering_potion.effect.thick": "Pozzion densa persistenta",
  "item.minecraft.lingering_potion.effect.turtle_master": "Pozzion persistenta del maester bissa scudellera",
  "item.minecraft.lingering_potion.effect.water": "Botilia d'aqua persistenta",
  "item.minecraft.lingering_potion.effect.water_breathing": "Pozzion persistenta de respirazzion aquatega",
  "item.minecraft.lingering_potion.effect.weakness": "Pozzion persistenta de debolezza",
  "item.minecraft.lingering_potion.effect.weaving": "Pozione persistente di tessitura",
  "item.minecraft.lingering_potion.effect.wind_charged": "Pozione persistente di carica ventosa",
  "item.minecraft.llama_spawn_egg": "Oeuv de lama",
  "item.minecraft.lodestone_compass": "Bussola magnetizada",
  "item.minecraft.mace": "Mazza",
  "item.minecraft.magenta_bundle": "Sacchetto magenta",
  "item.minecraft.magenta_dye": "Colorant magenta",
  "item.minecraft.magenta_harness": "Imbracatura magenta",
  "item.minecraft.magma_cream": "Crema de magma",
  "item.minecraft.magma_cube_spawn_egg": "Oeuv de cub de magma",
  "item.minecraft.mangrove_boat": "Barca de mangrovia",
  "item.minecraft.mangrove_chest_boat": "Barca de mangrovia con cesta",
  "item.minecraft.map": "Mapa voeuda",
  "item.minecraft.melon_seeds": "Somenza de inguria",
  "item.minecraft.melon_slice": "Feta de inguria",
  "item.minecraft.milk_bucket": "Sidell de lacc",
  "item.minecraft.minecart": "Carrell de minera",
  "item.minecraft.miner_pottery_shard": "Toch de terra-cota con picozz",
  "item.minecraft.miner_pottery_sherd": "Toch de terra-cota con picozz",
  "item.minecraft.mojang_banner_pattern": "Motiv de la bandera",
  "item.minecraft.mojang_banner_pattern.desc": "Loeugh",
  "item.minecraft.mojang_banner_pattern.new": "Motivo con logo",
  "item.minecraft.mooshroom_spawn_egg": "Oeuv de vaca-fonsg",
  "item.minecraft.mourner_pottery_shard": "Toch de terra-cota con warden",
  "item.minecraft.mourner_pottery_sherd": "Toch de terra-cota con warden",
  "item.minecraft.mule_spawn_egg": "Oeuv de mull",
  "item.minecraft.mushroom_stew": "Stracot de fonsg",
  "item.minecraft.music_disc_11": "Disch de musega",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Disch de musega",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Disch de musega",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Disch de musega",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Disch de musega",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Disch de musega",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Disco musicale",
  "item.minecraft.music_disc_creator.desc": "Lena Raine — Creator",
  "item.minecraft.music_disc_creator_music_box": "Disco musicale",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine — Creator (carillon)",
  "item.minecraft.music_disc_far": "Disch de musega",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Disco musicale",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Disch de musega",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Disch de musega",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Disch de musega",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Disch de musega",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Disco musicale",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof — Precipice",
  "item.minecraft.music_disc_relic": "Disch de musega",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Disch de musega",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Disch de musega",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Disco musicale",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy — Tears",
  "item.minecraft.music_disc_wait": "Disch de musega",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Disch de musega",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Bar crud",
  "item.minecraft.name_tag": "Eticheta",
  "item.minecraft.nautilus_shell": "Guss de nautilus",
  "item.minecraft.nautilus_spawn_egg": "Uovo generatore di nautilo",
  "item.minecraft.nether_brick": "Quadrell del Nether",
  "item.minecraft.nether_star": "Stella del Nether",
  "item.minecraft.nether_wart": "Brossera del Nether",
  "item.minecraft.netherite_axe": "Segurin de netherite",
  "item.minecraft.netherite_boots": "Strivai de netherite",
  "item.minecraft.netherite_chestplate": "Corazza de netherite",
  "item.minecraft.netherite_helmet": "Elm de netherite",
  "item.minecraft.netherite_hoe": "Zapa de netherite",
  "item.minecraft.netherite_horse_armor": "Bardatura di netherite",
  "item.minecraft.netherite_ingot": "Lingot de netherite",
  "item.minecraft.netherite_leggings": "Gambai de netherite",
  "item.minecraft.netherite_nautilus_armor": "Armatura di netherite per nautili",
  "item.minecraft.netherite_pickaxe": "Picozz de netherite",
  "item.minecraft.netherite_scrap": "Tochei de netherite",
  "item.minecraft.netherite_shovel": "Baira de netherite",
  "item.minecraft.netherite_spear": "Lancia di netherite",
  "item.minecraft.netherite_sword": "Spada de netherite",
  "item.minecraft.netherite_upgrade_smithing_template": "Model del ferrer",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Miglioramento di netherite",
  "item.minecraft.oak_boat": "Barca de cerr",
  "item.minecraft.oak_chest_boat": "Barca de rogora con cesta",
  "item.minecraft.ocelot_spawn_egg": "Oeuv de gatopard",
  "item.minecraft.ominous_bottle": "Ampolla infausta",
  "item.minecraft.ominous_trial_key": "Chiave della sfida infausta",
  "item.minecraft.orange_bundle": "Sacchetto arancione",
  "item.minecraft.orange_dye": "Colorant naranz",
  "item.minecraft.orange_harness": "Imbracatura arancione",
  "item.minecraft.painting": "Quader",
  "item.minecraft.pale_oak_boat": "Barca di quercia pallida",
  "item.minecraft.pale_oak_chest_boat": "Barca di quercia pallida con baule",
  "item.minecraft.panda_spawn_egg": "Oeuv de panda",
  "item.minecraft.paper": "Carta",
  "item.minecraft.parched_spawn_egg": "Uovo generatore di ossecco",
  "item.minecraft.parrot_spawn_egg": "Oeuv de papagall",
  "item.minecraft.phantom_membrane": "Membrana de fantasma",
  "item.minecraft.phantom_spawn_egg": "Oeuv de fantasma",
  "item.minecraft.pig_spawn_egg": "Oeuv de porscell",
  "item.minecraft.piglin_banner_pattern": "Motiv de la bandera",
  "item.minecraft.piglin_banner_pattern.desc": "Grugn",
  "item.minecraft.piglin_banner_pattern.new": "Motivo con grugno",
  "item.minecraft.piglin_brute_spawn_egg": "Oeuv de piglin brut",
  "item.minecraft.piglin_spawn_egg": "Oeuv de piglin",
  "item.minecraft.pillager_spawn_egg": "Oeuv de lader",
  "item.minecraft.pink_bundle": "Sacchetto rosa",
  "item.minecraft.pink_dye": "Colorant roeusa",
  "item.minecraft.pink_harness": "Imbracatura rosa",
  "item.minecraft.pitcher_plant": "Pianta carnivora",
  "item.minecraft.pitcher_pod": "Baccello di pianta carnivora",
  "item.minecraft.plenty_pottery_shard": "Toch de terra-cota con cesta",
  "item.minecraft.plenty_pottery_sherd": "Toch de terra-cota con cesta",
  "item.minecraft.poisonous_potato": "Pom de terra toeussega",
  "item.minecraft.polar_bear_spawn_egg": "Oeuv de ors polar",
  "item.minecraft.popped_chorus_fruit": "Frut de chorus s'ciopad",
  "item.minecraft.porkchop": "Brassoeula de porcell cruda",
  "item.minecraft.potato": "Pom de terra",
  "item.minecraft.potion": "Pozzion",
  "item.minecraft.potion.effect.awkward": "Pozzion strana",
  "item.minecraft.potion.effect.empty": "Pozzion che se poeu mìa fà su",
  "item.minecraft.potion.effect.fire_resistance": "Pozzion de resistenza al foeugh",
  "item.minecraft.potion.effect.harming": "Pozzion de dagn",
  "item.minecraft.potion.effect.healing": "Pozzion de cura",
  "item.minecraft.potion.effect.infested": "Pozione d'infestazione",
  "item.minecraft.potion.effect.invisibility": "Pozzion d'invisibilità",
  "item.minecraft.potion.effect.leaping": "Pozzion de salt",
  "item.minecraft.potion.effect.levitation": "Pozzion de levitazzion",
  "item.minecraft.potion.effect.luck": "Pozzion de fortuna",
  "item.minecraft.potion.effect.mundane": "Pozzion normala",
  "item.minecraft.potion.effect.night_vision": "Pozzion de la vision per la nocc",
  "item.minecraft.potion.effect.oozing": "Pozione di trasudazione",
  "item.minecraft.potion.effect.poison": "Pozzion de velen",
  "item.minecraft.potion.effect.regeneration": "Pozzion de regenerazzion",
  "item.minecraft.potion.effect.slow_falling": "Pozzion de borlada lenta",
  "item.minecraft.potion.effect.slowness": "Pozzion de lentezza",
  "item.minecraft.potion.effect.strength": "Pozzion de forza",
  "item.minecraft.potion.effect.swiftness": "Pozzion de sveltezza",
  "item.minecraft.potion.effect.thick": "Pozzion densa",
  "item.minecraft.potion.effect.turtle_master": "Pozzion del maester bissa scudellera",
  "item.minecraft.potion.effect.water": "Botilia d'aqua",
  "item.minecraft.potion.effect.water_breathing": "Pozzion de respirazzion aquatega",
  "item.minecraft.potion.effect.weakness": "Pozzion de debolezza",
  "item.minecraft.potion.effect.weaving": "Pozione di tessitura",
  "item.minecraft.potion.effect.wind_charged": "Pozione di carica ventosa",
  "item.minecraft.pottery_shard_archer": "Toch de terra-cota con arch",
  "item.minecraft.pottery_shard_arms_up": "Toch de terra-cota con figura",
  "item.minecraft.pottery_shard_prize": "Toch de terra-cota con bisgiô",
  "item.minecraft.pottery_shard_skull": "Toch de terra-cota con coo",
  "item.minecraft.powder_snow_bucket": "Sidel de fioca in polver",
  "item.minecraft.prismarine_crystals": "Cristai de prismarina",
  "item.minecraft.prismarine_shard": "Scheja de prismarina",
  "item.minecraft.prize_pottery_shard": "Toch de terra-cota con bisgiô",
  "item.minecraft.prize_pottery_sherd": "Toch de terra-cota con bisgiô",
  "item.minecraft.pufferfish": "Pess-balla",
  "item.minecraft.pufferfish_bucket": "Sidell con pess-balla",
  "item.minecraft.pufferfish_spawn_egg": "Oeuv de pess-balla",
  "item.minecraft.pumpkin_pie": "Torta de zuca",
  "item.minecraft.pumpkin_seeds": "Somenza de zuca",
  "item.minecraft.purple_bundle": "Sacchetto viola",
  "item.minecraft.purple_dye": "Colorant vioeula",
  "item.minecraft.purple_harness": "Imbracatura viola",
  "item.minecraft.quartz": "Quarz del Nether",
  "item.minecraft.rabbit": "Conili crud",
  "item.minecraft.rabbit_foot": "Sciampa de conili",
  "item.minecraft.rabbit_hide": "Pell de conili",
  "item.minecraft.rabbit_spawn_egg": "Oeuv de conili",
  "item.minecraft.rabbit_stew": "Stuvad de conili",
  "item.minecraft.raiser_armor_trim_smithing_template": "Model del ferrer",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Ornamento stile allevatore",
  "item.minecraft.ravager_spawn_egg": "Oeuv de s'cepa-tut",
  "item.minecraft.raw_copper": "Ram crud",
  "item.minecraft.raw_gold": "Or crud",
  "item.minecraft.raw_iron": "Ferr crud",
  "item.minecraft.recovery_compass": "Bussola del retrovà",
  "item.minecraft.red_bundle": "Sacchetto rosso",
  "item.minecraft.red_dye": "Colorant ross",
  "item.minecraft.red_harness": "Imbracatura rossa",
  "item.minecraft.redstone": "Polver de prejarossa",
  "item.minecraft.resin_brick": "Mattone di resina",
  "item.minecraft.resin_clump": "Grumo di resina",
  "item.minecraft.rib_armor_trim_smithing_template": "Model del ferrer",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ornamento stile costole",
  "item.minecraft.rotten_flesh": "Carna marscia",
  "item.minecraft.saddle": "Sella",
  "item.minecraft.salmon": "Salmon crud",
  "item.minecraft.salmon_bucket": "Sidell con salmon",
  "item.minecraft.salmon_spawn_egg": "Oeuv de salmon",
  "item.minecraft.scrape_pottery_sherd": "Coccio con raschiatura",
  "item.minecraft.scute": "Scuto",
  "item.minecraft.sentry_armor_trim_smithing_template": "Model del ferrer",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Ornamento stile sentinella",
  "item.minecraft.shaper_armor_trim_smithing_template": "Model del ferrer",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Ornamento stile modellatore",
  "item.minecraft.sheaf_pottery_shard": "Toch de terra-cota con fen",
  "item.minecraft.sheaf_pottery_sherd": "Toch de terra-cota con fen",
  "item.minecraft.shears": "S'cesora",
  "item.minecraft.sheep_spawn_egg": "Oeuv de pegora",
  "item.minecraft.shelter_pottery_shard": "Toch de terra-cota con refusg",
  "item.minecraft.shelter_pottery_sherd": "Toch de terra-cota con refusg",
  "item.minecraft.shield": "Scud",
  "item.minecraft.shield.black": "Scud negher",
  "item.minecraft.shield.blue": "Scud bloeu",
  "item.minecraft.shield.brown": "Scud marron",
  "item.minecraft.shield.cyan": "Scud celest",
  "item.minecraft.shield.gray": "Scud gris",
  "item.minecraft.shield.green": "Scud verd",
  "item.minecraft.shield.light_blue": "Scud bloeu ciar",
  "item.minecraft.shield.light_gray": "Scud gris ciar",
  "item.minecraft.shield.lime": "Scud lime",
  "item.minecraft.shield.magenta": "Scud magenta",
  "item.minecraft.shield.orange": "Scud naranz",
  "item.minecraft.shield.pink": "Scud roeusa",
  "item.minecraft.shield.purple": "Scud vioeula",
  "item.minecraft.shield.red": "Scud ross",
  "item.minecraft.shield.white": "Scud bianch",
  "item.minecraft.shield.yellow": "Scud sgiald",
  "item.minecraft.shulker_shell": "Guss de shulker",
  "item.minecraft.shulker_spawn_egg": "Oeuv de shulker",
  "item.minecraft.sign": "Cartell",
  "item.minecraft.silence_armor_trim_smithing_template": "Model del ferrer",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Ornamento stile silenzio",
  "item.minecraft.silverfish_spawn_egg": "Oeuv de pess d'arsgent",
  "item.minecraft.skeleton_horse_spawn_egg": "Oeuv de cavall schelter",
  "item.minecraft.skeleton_spawn_egg": "Oeuv de schelter",
  "item.minecraft.skull_banner_pattern": "Motiv de la bandera",
  "item.minecraft.skull_banner_pattern.desc": "Crani",
  "item.minecraft.skull_banner_pattern.new": "Motivo con teschio",
  "item.minecraft.skull_pottery_shard": "Toch de terra-cota con coo",
  "item.minecraft.skull_pottery_sherd": "Toch de terra-cota con coo",
  "item.minecraft.slime_ball": "Balla de slime",
  "item.minecraft.slime_spawn_egg": "Oeuv de slime",
  "item.minecraft.smithing_template": "Model del ferrer",
  "item.minecraft.smithing_template.applies_to": "El se aplica a:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Sgionta un lingot o un cristall",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armadura",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Sgionta una part de armadura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingot e cristall",
  "item.minecraft.smithing_template.ingredients": "Ingredient:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Sgionta un lingot de netherite",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Fornitù de diamant",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Sgionta un armadura, un'arma o un arnes de diamant",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingot de netherite",
  "item.minecraft.smithing_template.upgrade": "Mijoria: ",
  "item.minecraft.sniffer_spawn_egg": "Oeuv de nasador",
  "item.minecraft.snort_pottery_shard": "Toch de terra-cota con nasador",
  "item.minecraft.snort_pottery_sherd": "Toch de terra-cota con nasador",
  "item.minecraft.snout_armor_trim_smithing_template": "Model del ferrer",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Ornamento stile grugno",
  "item.minecraft.snow_golem_spawn_egg": "Oeuv de golem de nev",
  "item.minecraft.snowball": "Balla de fioca",
  "item.minecraft.spectral_arrow": "Flizza spetrala",
  "item.minecraft.spider_eye": "Oeugg de ragn",
  "item.minecraft.spider_spawn_egg": "Oeuv de ragn",
  "item.minecraft.spire_armor_trim_smithing_template": "Model del ferrer",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Ornamento stile guglie",
  "item.minecraft.splash_potion": "Pozzion de tirà",
  "item.minecraft.splash_potion.effect.awkward": "Pozzion strana de tirà",
  "item.minecraft.splash_potion.effect.empty": "Pozzion de tirà che se poeu mìa fà su",
  "item.minecraft.splash_potion.effect.fire_resistance": "Pozzion de tirà de resistenza al foeugh",
  "item.minecraft.splash_potion.effect.harming": "Pozzion de tirà de dagn",
  "item.minecraft.splash_potion.effect.healing": "Pozzion de tirà de cura",
  "item.minecraft.splash_potion.effect.infested": "Pozione da lancio d'infestazione",
  "item.minecraft.splash_potion.effect.invisibility": "Pozzion de tirà d'invisibilità",
  "item.minecraft.splash_potion.effect.leaping": "Pozzion de tirà de salt",
  "item.minecraft.splash_potion.effect.levitation": "Pozzion de tirà de levitazzion",
  "item.minecraft.splash_potion.effect.luck": "Pozzion de tirà de fortuna",
  "item.minecraft.splash_potion.effect.mundane": "Pozzion normala de tirà",
  "item.minecraft.splash_potion.effect.night_vision": "Pozzion de tirà de vision per la nocc",
  "item.minecraft.splash_potion.effect.oozing": "Pozione da lancio di trasudazione",
  "item.minecraft.splash_potion.effect.poison": "Pozzion de tirà de velen",
  "item.minecraft.splash_potion.effect.regeneration": "Pozzion de tirà de regenerazzion",
  "item.minecraft.splash_potion.effect.slow_falling": "Pozzion de tirà de borlada lenta",
  "item.minecraft.splash_potion.effect.slowness": "Pozzion de tirà de lentezza",
  "item.minecraft.splash_potion.effect.strength": "Pozzion de tirà de forza",
  "item.minecraft.splash_potion.effect.swiftness": "Pozzion de tirà de sveltezza",
  "item.minecraft.splash_potion.effect.thick": "Pozzion densa de tirà",
  "item.minecraft.splash_potion.effect.turtle_master": "Pozzion de tirà del maester bissa scudellera",
  "item.minecraft.splash_potion.effect.water": "Botilia d'aqua de tirà",
  "item.minecraft.splash_potion.effect.water_breathing": "Pozzion de tirà de respirazzion aquatega",
  "item.minecraft.splash_potion.effect.weakness": "Pozzion de tirà de debolezza",
  "item.minecraft.splash_potion.effect.weaving": "Pozione da lancio di tessitura",
  "item.minecraft.splash_potion.effect.wind_charged": "Pozione da lancio di carica ventosa",
  "item.minecraft.spruce_boat": "Barca de abiezz",
  "item.minecraft.spruce_chest_boat": "Barca de abiezz con cesta",
  "item.minecraft.spyglass": "Canoccial",
  "item.minecraft.squid_spawn_egg": "Oeuv de calamar",
  "item.minecraft.stick": "Baston",
  "item.minecraft.stone_axe": "Segurin de preja",
  "item.minecraft.stone_hoe": "Zapa de preja",
  "item.minecraft.stone_pickaxe": "Picozz de preja",
  "item.minecraft.stone_shovel": "Baira de preja",
  "item.minecraft.stone_spear": "Lancia di pietra",
  "item.minecraft.stone_sword": "Spada de preja",
  "item.minecraft.stray_spawn_egg": "Oeuv de schelter di nev",
  "item.minecraft.strider_spawn_egg": "Oeuv de strider",
  "item.minecraft.string": "Fil",
  "item.minecraft.sugar": "Zucher",
  "item.minecraft.suspicious_stew": "Supa sospeta",
  "item.minecraft.sweet_berries": "Frut dolz",
  "item.minecraft.tadpole_bucket": "Sidell con botarana",
  "item.minecraft.tadpole_spawn_egg": "Oeuv de botarana",
  "item.minecraft.tide_armor_trim_smithing_template": "Model del ferrer",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Ornamento stile marea",
  "item.minecraft.tipped_arrow": "Flizza guzza",
  "item.minecraft.tipped_arrow.effect.awkward": "Flizza imbibida",
  "item.minecraft.tipped_arrow.effect.empty": "Flizza imbibida che se poeu mìa fà su",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Flizza de resistenza al foeugh",
  "item.minecraft.tipped_arrow.effect.harming": "Flizza de dagn",
  "item.minecraft.tipped_arrow.effect.healing": "Flizza de cura",
  "item.minecraft.tipped_arrow.effect.infested": "Freccia d'infestazione",
  "item.minecraft.tipped_arrow.effect.invisibility": "Flizza de invisibilità",
  "item.minecraft.tipped_arrow.effect.leaping": "Flizza de salt",
  "item.minecraft.tipped_arrow.effect.levitation": "Flizza de levitazzion",
  "item.minecraft.tipped_arrow.effect.luck": "Flizza de fortuna",
  "item.minecraft.tipped_arrow.effect.mundane": "Flizza imbibida",
  "item.minecraft.tipped_arrow.effect.night_vision": "Flizza de vision per la nocc",
  "item.minecraft.tipped_arrow.effect.oozing": "Freccia di trasudazione",
  "item.minecraft.tipped_arrow.effect.poison": "Flizza de velen",
  "item.minecraft.tipped_arrow.effect.regeneration": "Flizza de regenerazzion",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Flizza de borlada lenta",
  "item.minecraft.tipped_arrow.effect.slowness": "Flizza de lentezza",
  "item.minecraft.tipped_arrow.effect.strength": "Flizza de forza",
  "item.minecraft.tipped_arrow.effect.swiftness": "Flizza de sveltezza",
  "item.minecraft.tipped_arrow.effect.thick": "Flizza imbibida",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Flizza del maester bissa scudellera",
  "item.minecraft.tipped_arrow.effect.water": "Flizza d'aqua",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Flizza de respirazzion aquatega",
  "item.minecraft.tipped_arrow.effect.weakness": "Flizza de debolezza",
  "item.minecraft.tipped_arrow.effect.weaving": "Freccia di tessitura",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Freccia di carica ventosa",
  "item.minecraft.tnt_minecart": "Carrell de minera con dimanit",
  "item.minecraft.torchflower_seeds": "Somenza de torcia-fior",
  "item.minecraft.totem_of_undying": "Totem de l'imortalità",
  "item.minecraft.trader_llama_spawn_egg": "Oeuv de lama ramingh",
  "item.minecraft.trial_key": "Chiave della sfida",
  "item.minecraft.trident": "Trident",
  "item.minecraft.tropical_fish": "Pess tropegal",
  "item.minecraft.tropical_fish_bucket": "Sidell de pess tropegal",
  "item.minecraft.tropical_fish_spawn_egg": "Oeuv de pess tropegal",
  "item.minecraft.turtle_helmet": "Guss de bissa scudellera",
  "item.minecraft.turtle_scute": "Scuto di tartaruga",
  "item.minecraft.turtle_spawn_egg": "Oeuv de bissa scudellera",
  "item.minecraft.vex_armor_trim_smithing_template": "Model del ferrer",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Ornamento stile vessante",
  "item.minecraft.vex_spawn_egg": "Oeuv de spirit",
  "item.minecraft.villager_spawn_egg": "Oeuv de paisan",
  "item.minecraft.vindicator_spawn_egg": "Oeuv de vendegador",
  "item.minecraft.wandering_trader_spawn_egg": "Oeuv de mercant ramingh",
  "item.minecraft.ward_armor_trim_smithing_template": "Model del ferrer",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ornamento stile sorvegliante",
  "item.minecraft.warden_spawn_egg": "Oeuv de warden",
  "item.minecraft.warped_fungus_on_a_stick": "Baston con fonsg desformad",
  "item.minecraft.water_bucket": "Sidell d'aqua",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Model del ferrer",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Ornamento stile ricognitore",
  "item.minecraft.wheat": "Forment",
  "item.minecraft.wheat_seeds": "Somenza de forment",
  "item.minecraft.white_bundle": "Sacchetto bianco",
  "item.minecraft.white_dye": "Colorant bianch",
  "item.minecraft.white_harness": "Imbracatura bianca",
  "item.minecraft.wild_armor_trim_smithing_template": "Model del ferrer",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Ornamento stile selvaggio",
  "item.minecraft.wind_charge": "Carica di vento",
  "item.minecraft.witch_spawn_egg": "Oeuv de stria",
  "item.minecraft.wither_skeleton_spawn_egg": "Oeuv de schelter wither",
  "item.minecraft.wither_spawn_egg": "Oeuv de wither",
  "item.minecraft.wolf_armor": "Armatura per lupi",
  "item.minecraft.wolf_spawn_egg": "Oeuv de lov",
  "item.minecraft.wooden_axe": "Segurin de legn",
  "item.minecraft.wooden_hoe": "Zapa de legn",
  "item.minecraft.wooden_pickaxe": "Picozz de legn",
  "item.minecraft.wooden_shovel": "Baira de legn",
  "item.minecraft.wooden_spear": "Lancia di legno",
  "item.minecraft.wooden_sword": "Spada de legn",
  "item.minecraft.writable_book": "Liber e pena",
  "item.minecraft.written_book": "Liber scrit",
  "item.minecraft.yellow_bundle": "Sacchetto giallo",
  "item.minecraft.yellow_dye": "Colorant sgiald",
  "item.minecraft.yellow_harness": "Imbracatura gialla",
  "item.minecraft.zoglin_spawn_egg": "Oeuv de zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Oeuv de cavall zombie",
  "item.minecraft.zombie_nautilus_spawn_egg": "Uovo generatore di nautilo zombi",
  "item.minecraft.zombie_spawn_egg": "Oeuv de zombie",
  "item.minecraft.zombie_villager_spawn_egg": "Oeuv de paisan zombie",
  "item.minecraft.zombified_piglin_spawn_egg": "Oeuv de piglin zombifegad"
}
export const lmo = items; 
